import React, { useState, useEffect } from 'react';

// --- Стили (с адаптивом для мобильных) ---
const styles = {
  container: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '20px',
    fontFamily: 'Arial, sans-serif'
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '30px',
    borderBottom: '2px solid #007bff',
    paddingBottom: '10px',
    flexWrap: 'wrap'
  },
  tabButton: (isActive) => ({
    background: isActive ? '#007bff' : '#f1f1f1',
    color: isActive ? 'white' : '#333',
    border: 'none',
    padding: '10px 20px',
    fontSize: '18px',
    cursor: 'pointer',
    borderRadius: '8px',
    transition: '0.3s'
  }),
  stats: {
    display: 'flex',
    gap: '20px',
    background: '#e9ecef',
    padding: '10px 20px',
    borderRadius: '8px',
    flexWrap: 'wrap',
    fontSize: '14px'
  },
  form: {
    background: '#f9f9f9',
    padding: '20px',
    borderRadius: '12px',
    marginBottom: '30px',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px'
  },
  formRow: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
    gap: '15px'
  },
  input: {
    padding: '12px',
    borderRadius: '6px',
    border: '1px solid #ccc',
    fontSize: '16px',
    fontFamily: 'Arial, sans-serif'
  },
  button: {
    background: '#28a745',
    color: 'white',
    border: 'none',
    padding: '12px 20px',
    borderRadius: '6px',
    cursor: 'pointer',
    fontWeight: 'bold',
    fontSize: '16px'
  },
  dangerButton: {
    background: '#dc3545',
    color: 'white',
    border: 'none',
    padding: '8px 12px',
    borderRadius: '4px',
    cursor: 'pointer',
    marginRight: '5px',
    fontSize: '14px'
  },
  editButton: {
    background: '#ffc107',
    color: '#333',
    border: 'none',
    padding: '8px 12px',
    borderRadius: '4px',
    cursor: 'pointer',
    marginRight: '5px',
    fontSize: '14px'
  },
  addButton: {
    background: '#17a2b8',
    color: 'white',
    border: 'none',
    padding: '8px 12px',
    borderRadius: '4px',
    cursor: 'pointer',
    marginTop: '5px',
    fontSize: '14px'
  },
  thTd: {
    border: '1px solid #ddd',
    padding: '8px',
    textAlign: 'left'
  },
  workItem: {
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
    marginBottom: '10px',
    flexWrap: 'wrap'
  },
  centerButton: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '20px'
  },
  currentSum: {
    background: '#d1ecf1',
    padding: '10px 15px',
    borderRadius: '8px',
    marginBottom: '15px',
    textAlign: 'center',
    fontSize: '18px',
    fontWeight: 'bold'
  },
  syncStatus: {
    fontSize: '12px',
    color: '#28a745',
    marginLeft: '10px'
  },
  profitPanel: {
    display: 'flex',
    gap: '20px',
    marginBottom: '30px',
    flexWrap: 'wrap'
  },
  userCard: (isPositive) => ({
    flex: 1,
    background: '#f8f9fa',
    borderRadius: '12px',
    padding: '20px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    borderLeft: `4px solid ${isPositive ? '#28a745' : '#dc3545'}`
  }),
  profitRow: {
    display: 'flex',
    gap: '10px',
    marginTop: '15px'
  },
  profitMain: {
    flex: '0 0 50%',
    background: '#e9ecef',
    padding: '15px',
    borderRadius: '8px',
    textAlign: 'center'
  },
  profitSide: {
    flex: '0 0 25%',
    background: '#e9ecef',
    padding: '15px',
    borderRadius: '8px',
    textAlign: 'center'
  },
  profitDebt: (debtAmount, isViewer) => {
    let bgColor = '#e9ecef';
    if (debtAmount > 0) bgColor = '#dc3545';
    if (debtAmount < 0) bgColor = '#28a745';
    if (debtAmount === 0 && !isViewer) return { display: 'none' };
    return {
      flex: debtAmount === 0 ? '0 0 10%' : '0 0 25%',
      background: bgColor,
      padding: '15px',
      borderRadius: '8px',
      textAlign: 'center',
      color: debtAmount !== 0 ? 'white' : '#333'
    };
  },
  historyWindow: {
    background: '#fff',
    border: '1px solid #dee2e6',
    borderRadius: '12px',
    height: '300px',
    overflowY: 'auto',
    padding: '15px',
    marginBottom: '20px'
  },
  historyItem: {
    padding: '10px',
    borderBottom: '1px solid #eee',
    fontSize: '14px'
  },
  selectInput: {
    padding: '12px',
    borderRadius: '6px',
    border: '1px solid #ccc',
    fontSize: '16px',
    backgroundColor: 'white'
  },
  squareButton: {
    background: '#28a745',
    color: 'white',
    border: 'none',
    padding: '12px',
    borderRadius: '8px',
    cursor: 'pointer',
    fontWeight: 'bold',
    fontSize: '16px',
    minWidth: '80px',
    minHeight: '48px'
  }
};

const MobileStyles = () => {
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      input, select, textarea { font-size: 16px !important; }
      @media (max-width: 768px) {
        div[style*="overflowX: auto"] { -webkit-overflow-scrolling: touch; }
        table { min-width: 600px; }
        body { margin: 0; padding: 0; }
        input, select, textarea { font-size: 16px !important; }
        button { min-height: 44px; }
        .work-item-mobile { flex-direction: column; align-items: stretch !important; }
        .work-item-mobile input { width: 100%; }
        .stats-mobile { margin-top: 10px; width: 100%; justify-content: center; }
        .profit-row-mobile { flex-direction: column; }
        .profit-row-mobile > div { width: 100% !important; margin-bottom: 10px; }
      }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);
  return null;
};

// --- API НАСТРОЙКИ ---
const API_URL = 'https://inzhstroy-msk.ru/api';

// --- Компонент защиты паролем для главного приложения ---
const PasswordGuard = ({ children }) => {
  const [password, setPassword] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password === 'toto79ug') {
      setIsAuthenticated(true);
    } else {
      alert('Неверный пароль!');
    }
  };

  if (isAuthenticated) return children;

  return (
    <div style={{ textAlign: 'center', marginTop: '100px' }}>
      <h2>🔒 Доступ к системе учёта ограничен</h2>
      <form onSubmit={handleSubmit} style={{ display: 'inline-block', marginTop: '20px' }}>
        <input
          type="password"
          placeholder="Введите пароль"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={styles.input}
          autoFocus
        />
        <button type="submit" style={{ ...styles.button, marginLeft: '10px' }}>Войти</button>
      </form>
    </div>
  );
};

// --- Компонент защиты для страницы рентабельности ---
const ProfitabilityGuard = ({ children }) => {
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (login === 'admin' && password === 'kAmtot$ot41') {
      setIsAuthenticated(true);
    } else {
      alert('Неверный логин или пароль!');
    }
  };

  if (isAuthenticated) return children;

  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h2>🔐 Доступ к странице "Рентабельность"</h2>
      <form onSubmit={handleSubmit} style={{ display: 'inline-block', marginTop: '20px' }}>
        <div style={{ marginBottom: '10px' }}>
          <input
            type="text"
            placeholder="Логин"
            value={login}
            onChange={(e) => setLogin(e.target.value)}
            style={styles.input}
          />
        </div>
        <div style={{ marginBottom: '10px' }}>
          <input
            type="password"
            placeholder="Пароль"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={styles.input}
          />
        </div>
        <button type="submit" style={styles.button}>Войти</button>
      </form>
    </div>
  );
};

// --- Страница 1: Учёт товаров (с приходом) ---
const InventoryPage = ({ items, setItems, onLoadItems }) => {
  // ===== API URL =====
  // const API_URL = 'https://inzhstroy-msk.ru/api';
  
  // ===== СОСТОЯНИЕ ДЛЯ МОБИЛЬНОЙ ВЕРСИИ =====
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  // ===== СТИЛИ =====
  const styles = {
    container: {
      padding: '20px',
      maxWidth: '1400px',
      margin: '0 auto'
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexWrap: 'wrap',
      marginBottom: '20px',
      gap: '15px'
    },
    title: {
      margin: 0,
      fontSize: '24px',
      fontWeight: 'bold'
    },
    stats: {
      display: 'flex',
      gap: '20px',
      background: '#e9ecef',
      padding: '10px 20px',
      borderRadius: '8px',
      fontSize: '14px',
      flexWrap: 'wrap'
    },
    statItem: {
      display: 'flex',
      gap: '8px',
      alignItems: 'center'
    },
    statLabel: {
      color: '#666'
    },
    statValue: {
      fontWeight: 'bold'
    },
    form: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '10px',
      marginBottom: '20px',
      padding: '15px',
      background: '#f8f9fa',
      borderRadius: '8px',
      alignItems: 'center'
    },
    formRow: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '10px',
      flex: 1
    },
    input: {
      padding: '6px 8px',
      border: '1px solid #ced4da',
      borderRadius: '4px',
      fontSize: '13px',
      flex: 1,
      minWidth: '80px',
      outline: 'none',
      backgroundColor: '#fff',
      transition: 'border-color 0.15s',
      boxSizing: 'border-box'
    },
    button: {
      padding: '8px 20px',
      background: '#007bff',
      color: 'white',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
      fontSize: '14px',
      fontWeight: 'bold',
      transition: 'all 0.2s'
    },
    addButton: {
      padding: '5px 15px',
      background: '#28a745',
      color: 'white',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
      fontSize: '13px'
    },
    editButton: {
      padding: '4px 8px',
      background: '#ffc107',
      color: '#212529',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
      marginRight: '4px'
    },
    dangerButton: {
      padding: '4px 8px',
      background: '#dc3545',
      color: 'white',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer'
    },
    thTd: {
      padding: '6px 4px',
      border: '1px solid #dee2e6',
      textAlign: 'left',
      verticalAlign: 'middle',
      fontSize: '13px',
      position: 'relative',
      whiteSpace: 'nowrap'
    },
    incomingForm: {
      background: '#f8f9fa',
      borderRadius: '12px',
      padding: '20px',
      marginBottom: '20px',
      border: '2px solid #28a745'
    },
    incomingTitle: {
      margin: '0 0 15px 0',
      color: '#28a745'
    },
    expensesBlock: {
      marginBottom: '20px'
    },
    expensesTotal: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginTop: '10px',
      padding: '10px',
      background: '#e9ecef',
      borderRadius: '8px',
      fontWeight: 'bold',
      fontSize: '16px'
    },
    historyBlock: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '10px',
      marginBottom: '20px',
      padding: '10px',
      background: '#f8f9fa',
      borderRadius: '8px',
      border: '1px solid #dee2e6'
    },
    historyLabel: {
      fontSize: '14px',
      fontWeight: 'bold',
      color: '#666',
      marginRight: '10px'
    },
    historyItem: {
      padding: '4px 12px',
      background: '#e3f2fd',
      borderRadius: '16px',
      fontSize: '13px',
      cursor: 'pointer',
      border: '1px solid #bbdefb',
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      transition: 'all 0.2s'
    },
    searchWrapper: {
      marginBottom: '20px',
      display: 'flex',
      gap: '10px',
      alignItems: 'center'
    },
    searchInput: {
      flex: 1,
      padding: '8px 12px',
      border: '1px solid #ced4da',
      borderRadius: '4px',
      fontSize: '14px',
      outline: 'none',
      backgroundColor: '#fff',
      position: 'relative'
    },
    clearButton: {
      position: 'absolute',
      right: '10px',
      top: '50%',
      transform: 'translateY(-50%)',
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      fontSize: '18px',
      color: '#999',
      padding: '5px'
    },
    table: {
      width: '100%',
      minWidth: '800px',
      borderCollapse: 'separate',
      borderSpacing: 0
    },
    coefficient: {
      fontWeight: 'bold'
    },
    editModeBadge: {
      marginLeft: '10px',
      padding: '5px 15px',
      background: '#fff3cd',
      borderRadius: '20px',
      fontSize: '14px'
    },
    searchCell: {
      padding: '6px 4px',
      border: '1px solid #dee2e6',
      textAlign: 'left',
      verticalAlign: 'middle',
      fontSize: '13px',
      position: 'relative',
      minWidth: '180px'
    },
    searchInputWrapper: {
      position: 'relative',
      width: '100%'
    },
    suggestionsContainer: {
      position: 'absolute',
      top: 'calc(100% + 2px)',
      left: 0,
      right: 0,
      background: 'white',
      border: '1px solid #ddd',
      borderRadius: '4px',
      maxHeight: '200px',
      overflowY: 'auto',
      zIndex: 9999,
      boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
    },
    suggestionItem: {
      padding: '10px 12px',
      cursor: 'pointer',
      borderBottom: '1px solid #eee',
      transition: 'background 0.15s'
    },
    suggestionName: {
      fontWeight: 'bold',
      fontSize: '14px'
    },
    suggestionDetails: {
      fontSize: '12px',
      color: '#666',
      marginTop: '2px'
    },
    loadingIndicator: {
      position: 'absolute',
      right: '8px',
      top: '50%',
      transform: 'translateY(-50%)',
      color: '#666',
      fontSize: '12px',
      zIndex: 10000
    },
    // МОБИЛЬНЫЕ КАРТОЧКИ
    mobileCard: {
      background: 'white',
      border: '1px solid #dee2e6',
      borderRadius: '8px',
      padding: '12px',
      marginBottom: '12px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
    },
    mobileCardHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '10px',
      paddingBottom: '8px',
      borderBottom: '1px solid #e9ecef'
    },
    mobileCardTitle: {
      fontSize: '14px',
      fontWeight: 'bold',
      color: '#495057'
    },
    mobileFieldGroup: {
      marginBottom: '8px'
    },
    mobileLabel: {
      fontSize: '12px',
      color: '#6c757d',
      marginBottom: '4px',
      fontWeight: '500'
    },
    mobileInput: {
      width: '100%',
      padding: '8px 10px',
      border: '1px solid #ced4da',
      borderRadius: '4px',
      fontSize: '14px',
      boxSizing: 'border-box'
    },
    mobileRow: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '8px',
      marginBottom: '8px'
    },
    // 🔥 НОВЫЕ СТИЛИ ДЛЯ СУММ
    summaryBlock: {
      background: '#e9ecef',
      borderRadius: '8px',
      padding: '15px',
      marginBottom: '20px',
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
      gap: '15px'
    },
    summaryItem: {
      display: 'flex',
      flexDirection: 'column',
      gap: '4px'
    },
    summaryLabel: {
      fontSize: '12px',
      color: '#666',
      fontWeight: '500'
    },
    summaryValue: {
      fontSize: '18px',
      fontWeight: 'bold'
    }
  };

  // ===== СОСТОЯНИЯ =====
  const [form, setForm] = useState({ name: '', model: '', sku: '', cost: '', price: '', quantity: 1 });
  const [editId, setEditId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  
  const [showIncomingForm, setShowIncomingForm] = useState(false);
  const [incomingItems, setIncomingItems] = useState([
    { id: Date.now(), name: '', model: '', sku: '', cost: '', quantity: 1, price: '', extraCost: 0 }
  ]);
  const [expenses, setExpenses] = useState([
    { id: Date.now(), name: '', amount: '' }
  ]);
  const [incomingHistory, setIncomingHistory] = useState([]);
  const [editingIncomingId, setEditingIncomingId] = useState(null);
  
  const [searchSuggestions, setSearchSuggestions] = useState({});
  const [isSearching, setIsSearching] = useState({});
  const [searchTimeout, setSearchTimeout] = useState({});

  useEffect(() => {
    loadIncomingHistory();
  }, []);

  const loadIncomingHistory = async () => {
    try {
      const response = await fetch(`${API_URL}/incoming.php`);
      const data = await response.json();
      if (Array.isArray(data)) {
        setIncomingHistory(data);
      }
    } catch (error) {
      console.error('Ошибка загрузки истории приходов:', error);
    }
  };

  // 🔥 ФУНКЦИЯ ДЛЯ РАСЧЁТА СУММ ПРИХОДА
  const calculateIncomingTotals = () => {
    // Сумма себестоимости всех товаров
    const totalCost = incomingItems.reduce((sum, item) => {
      const cost = parseFloat(item.cost) || 0;
      const quantity = parseInt(item.quantity) || 0;
      return sum + (cost * quantity);
    }, 0);
    
    // Сумма доп. расходов на все товары
    const totalExtraCost = incomingItems.reduce((sum, item) => {
      const extraCost = parseFloat(item.extraCost) || 0;
      const quantity = parseInt(item.quantity) || 0;
      return sum + (extraCost * quantity);
    }, 0);
    
    // Сумма цен реализации всех товаров
    const totalPrice = incomingItems.reduce((sum, item) => {
      const price = parseFloat(item.price) || 0;
      const quantity = parseInt(item.quantity) || 0;
      return sum + (price * quantity);
    }, 0);
    
    // Общая сумма расходов (сопутствующие)
    const totalExpensesSum = expenses.reduce((sum, exp) => sum + (parseFloat(exp.amount) || 0), 0);
    
    // Итоговая себестоимость с расходами
    const totalWithExpenses = totalCost + totalExtraCost + totalExpensesSum;
    
    // Коэффициент (если есть продажная цена)
    const coefficient = totalWithExpenses > 0 && totalPrice > 0 
      ? (totalPrice / totalWithExpenses).toFixed(2) 
      : '0.00';
    
    return {
      totalCost,
      totalExtraCost,
      totalPrice,
      totalExpensesSum,
      totalWithExpenses,
      coefficient
    };
  };

  const clearSearch = () => {
    setSearchTerm('');
  };

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const addIncomingItem = () => {
    setIncomingItems([...incomingItems, { 
      id: Date.now(), 
      name: '', 
      model: '', 
      sku: '', 
      cost: '', 
      quantity: 1,
      price: '',
      extraCost: 0 
    }]);
  };

  const removeIncomingItem = (id) => {
    if (incomingItems.length === 1) {
      alert('Должен быть хотя бы один товар');
      return;
    }
    setIncomingItems(incomingItems.filter(item => item.id !== id));
  };

  const updateIncomingItem = (id, field, value) => {
    setIncomingItems(incomingItems.map(item => 
      item.id === id ? { ...item, [field]: value } : item
    ));
  };

  const searchItemsInDB = async (query, itemId) => {
    if (searchTimeout[itemId]) {
      clearTimeout(searchTimeout[itemId]);
    }

    if (query.length < 2) {
      setSearchSuggestions(prev => ({ ...prev, [itemId]: [] }));
      setIsSearching(prev => ({ ...prev, [itemId]: false }));
      return;
    }

    setIsSearching(prev => ({ ...prev, [itemId]: true }));

    const timeoutId = setTimeout(async () => {
      try {
        const response = await fetch(`${API_URL}/search_items.php?q=${encodeURIComponent(query)}`);
        const results = await response.json();
        setSearchSuggestions(prev => ({ ...prev, [itemId]: results }));
      } catch (error) {
        console.error('Ошибка поиска:', error);
        setSearchSuggestions(prev => ({ ...prev, [itemId]: [] }));
      } finally {
        setIsSearching(prev => ({ ...prev, [itemId]: false }));
      }
    }, 300);

    setSearchTimeout(prev => ({ ...prev, [itemId]: timeoutId }));
  };

  const selectSuggestion = (itemId, suggestion) => {
    setIncomingItems(incomingItems.map(item => {
      if (item.id === itemId) {
        return {
          ...item,
          name: suggestion.name,
          model: suggestion.model || '',
          sku: suggestion.sku || '',
          cost: suggestion.cost || '',
          price: suggestion.price || '',
          extraCost: suggestion.extra_cost || 0
        };
      }
      return item;
    }));
    setSearchSuggestions(prev => ({ ...prev, [itemId]: [] }));
  };

  const addExpense = () => {
    setExpenses([...expenses, { id: Date.now(), name: '', amount: '' }]);
  };

  const removeExpense = (id) => {
    if (expenses.length === 1) {
      alert('Должен быть хотя бы один расход');
      return;
    }
    setExpenses(expenses.filter(exp => exp.id !== id));
  };

  const updateExpense = (id, field, value) => {
    setExpenses(expenses.map(exp => 
      exp.id === id ? { ...exp, [field]: value } : exp
    ));
  };

  const totalExpenses = expenses.reduce((sum, exp) => sum + (parseFloat(exp.amount) || 0), 0);

  const distributeExpenses = (items, totalExp) => {
    const totalCost = items.reduce((sum, item) => {
      const cost = parseFloat(item.cost) || 0;
      const quantity = parseInt(item.quantity) || 0;
      return sum + (cost * quantity);
    }, 0);
    
    if (totalCost === 0 || totalExp === 0) {
      return items.map(item => ({ ...item, extraCost: 0 }));
    }
    
    return items.map(item => {
      const cost = parseFloat(item.cost) || 0;
      const quantity = parseInt(item.quantity) || 0;
      const itemTotalCost = cost * quantity;
      const extraCost = (itemTotalCost / totalCost) * totalExp;
      return { ...item, extraCost: extraCost / quantity };
    });
  };

  const editIncomingOrder = async (orderId) => {
    try {
      const response = await fetch(`${API_URL}/incoming.php?id=${orderId}`);
      const order = await response.json();
      
      if (order) {
        setEditingIncomingId(orderId);
        setShowIncomingForm(true);
        
        const itemsWithId = order.items.map(item => ({
          id: Date.now() + Math.random(),
          name: item.name,
          model: item.model || '',
          sku: item.sku || '',
          cost: item.cost || '',
          quantity: item.quantity || 1,
          price: item.price || '',
          extraCost: item.extraCost || 0
        }));
        setIncomingItems(itemsWithId);
        
        // ✅ Загружаем расходы
        if (order.expenses && order.expenses.length > 0) {
          const expensesWithId = order.expenses.map(exp => ({
            id: Date.now() + Math.random(),
            name: exp.name,
            amount: exp.amount || ''
          }));
          setExpenses(expensesWithId);
        } else {
          setExpenses([{ id: Date.now(), name: '', amount: '' }]);
        }
        
        document.getElementById('incomingForm')?.scrollIntoView({ behavior: 'smooth' });
      }
    } catch (error) {
      console.error('Ошибка загрузки прихода для редактирования:', error);
      alert('Не удалось загрузить данные для редактирования');
    }
  };

  const handleIncomingSubmit = async () => {
    const validItems = incomingItems.filter(item => item.name.trim() && item.cost);
    if (validItems.length === 0) {
      alert('Добавьте хотя бы один товар с названием и себестоимостью');
      return;
    }

    setLoading(true);
    try {
      const itemsWithExtra = distributeExpenses(validItems, totalExpenses);
      
      const incomingData = {
        date: new Date().toISOString(),
        items: itemsWithExtra.map(item => ({
          name: item.name,
          model: item.model || '',
          sku: item.sku || '',
          cost: parseFloat(item.cost) || 0,
          price: parseFloat(item.price) || 0,
          quantity: parseInt(item.quantity) || 0,
          extraCost: item.extraCost || 0
        })),
        expenses: expenses.filter(e => e.name.trim() && e.amount).map(e => ({
          name: e.name,
          amount: parseFloat(e.amount) || 0
        })),
        totalExpenses: totalExpenses
      };

      if (editingIncomingId) {
        incomingData.editId = editingIncomingId;
      }

      const response = await fetch(`${API_URL}/incoming.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(incomingData)
      });

      const result = await response.json();
      
      if (result.success) {
        await onLoadItems();
        await loadIncomingHistory();
        resetIncomingForm();
        alert(editingIncomingId ? '✅ Приход обновлён!' : '✅ Приход успешно сохранён!');
      } else {
        alert(`❌ Ошибка: ${result.error || 'Неизвестная ошибка'}`);
      }
    } catch (error) {
      console.error('Ошибка сохранения прихода:', error);
      alert('Ошибка при сохранении прихода');
    } finally {
      setLoading(false);
    }
  };

  const resetIncomingForm = () => {
    setShowIncomingForm(false);
    setIncomingItems([{ id: Date.now(), name: '', model: '', sku: '', cost: '', quantity: 1, price: '', extraCost: 0 }]);
    setExpenses([{ id: Date.now(), name: '', amount: '' }]);
    setEditingIncomingId(null);
    setSearchSuggestions({});
    setIsSearching({});
    Object.values(searchTimeout).forEach(timeout => clearTimeout(timeout));
    setSearchTimeout({});
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.cost || !form.price) {
      alert('Заполните обязательные поля: Название, Себестоимость, Цена реализации');
      return;
    }
    
    setLoading(true);
    try {
      if (editId !== null) {
        const updatedItem = { 
          id: editId,
          name: form.name,
          model: form.model || '',
          sku: form.sku || '',
          cost: parseFloat(form.cost),
          price: parseFloat(form.price),
          quantity: parseInt(form.quantity) || 0
        };
        await fetch(`${API_URL}/items.php`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(updatedItem)
        });
        setEditId(null);
      } else {
        const newItem = {
          name: form.name,
          model: form.model || '',
          sku: form.sku || '',
          cost: parseFloat(form.cost),
          price: parseFloat(form.price),
          quantity: parseInt(form.quantity) || 1
        };
        await fetch(`${API_URL}/items.php`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(newItem)
        });
      }
      
      await onLoadItems();
      setForm({ name: '', model: '', sku: '', cost: '', price: '', quantity: 1 });
      alert(editId ? '✅ Товар обновлён!' : '✅ Товар добавлен на склад!');
    } catch (error) {
      console.error('Ошибка сохранения:', error);
      alert('Ошибка при сохранении товара');
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (item) => {
    setForm({ 
      name: item.name, 
      model: item.model || '', 
      sku: item.sku || '', 
      cost: item.cost, 
      price: item.price, 
      quantity: item.quantity 
    });
    setEditId(item.id);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Удалить товар?')) return;
    
    setLoading(true);
    try {
      await fetch(`${API_URL}/items.php?id=${id}`, { method: 'DELETE' });
      await onLoadItems();
      alert('✅ Товар удалён');
    } catch (error) {
      console.error('Ошибка удаления:', error);
      alert('Ошибка при удалении товара');
    } finally {
      setLoading(false);
    }
  };

  const deleteIncomingOrder = async (orderId, e) => {
    e.stopPropagation();
    if (!window.confirm('Удалить этот приход?')) return;
    
    try {
      const response = await fetch(`${API_URL}/incoming.php?id=${orderId}`, {
        method: 'DELETE'
      });
      const result = await response.json();
      
      if (result.success) {
        alert('✅ Приход удалён');
        await loadIncomingHistory();
        await onLoadItems();
      } else {
        alert('❌ Ошибка удаления');
      }
    } catch (error) {
      console.error('Ошибка:', error);
      alert('Ошибка при удалении');
    }
  };

  const filteredItems = items.filter(item => {
    const searchLower = searchTerm.toLowerCase();
    return (
      item.name.toLowerCase().includes(searchLower) ||
      (item.sku && item.sku.toLowerCase().includes(searchLower)) ||
      (item.model && item.model.toLowerCase().includes(searchLower))
    );
  });

  const totalCost = items.reduce((sum, item) => sum + (item.cost * item.quantity), 0);
  const totalExtraCost = items.reduce((sum, item) => sum + ((item.extra_cost || 0) * item.quantity), 0);
  const totalPrice = items.reduce((sum, item) => sum + (item.price * item.quantity), 0);
  const totalWithExtra = totalCost + totalExtraCost;
  const coefficient = totalWithExtra > 0 ? (totalPrice / totalWithExtra).toFixed(2) : '0.00';

  // 🔥 Компонент для отображения сумм прихода
  const IncomingSummary = () => {
    const totals = calculateIncomingTotals();
    
    return (
      <div style={styles.summaryBlock}>
        <div style={styles.summaryItem}>
          <span style={styles.summaryLabel}>💰 Себестоимость</span>
          <span style={styles.summaryValue}>{totals.totalCost.toFixed(2)} ₽</span>
        </div>
        <div style={styles.summaryItem}>
          <span style={styles.summaryLabel}>📊 Доп. расходы</span>
          <span style={styles.summaryValue}>{totals.totalExtraCost.toFixed(2)} ₽</span>
        </div>
        <div style={styles.summaryItem}>
          <span style={styles.summaryLabel}>💳 Сопутствующие расходы</span>
          <span style={styles.summaryValue}>{totals.totalExpensesSum.toFixed(2)} ₽</span>
        </div>
        <div style={styles.summaryItem}>
          <span style={styles.summaryLabel}>💵 Цена реализации</span>
          <span style={styles.summaryValue}>{totals.totalPrice.toFixed(2)} ₽</span>
        </div>
        <div style={styles.summaryItem}>
          <span style={styles.summaryLabel}>📈 Коэффициент поставки</span>
          <span style={{
            ...styles.summaryValue,
            color: parseFloat(totals.coefficient) >= 1 ? '#28a745' : '#dc3545'
          }}>
            ⨯{totals.coefficient}
          </span>
        </div>
      </div>
    );
  };

  // 🔥 Мобильная карточка товара
  const MobileItemCard = ({ item, index }) => {
    const suggestions = searchSuggestions[item.id] || [];
    const isSearchingItem = isSearching[item.id] || false;
    
    return (
      <div style={styles.mobileCard}>
        <div style={styles.mobileCardHeader}>
          <span style={styles.mobileCardTitle}>📦 Товар #{index + 1}</span>
          <button
            type="button"
            style={styles.dangerButton}
            onClick={() => removeIncomingItem(item.id)}
          >
            🗑️ Удалить
          </button>
        </div>
        
        <div style={styles.mobileFieldGroup}>
          <div style={styles.mobileLabel}>Название *</div>
          <div style={styles.searchInputWrapper}>
            <input
              style={{
                ...styles.mobileInput,
                paddingRight: isSearchingItem ? '30px' : '10px'
              }}
              placeholder="Название"
              value={item.name}
              onChange={(e) => {
                const val = e.target.value;
                updateIncomingItem(item.id, 'name', val);
                searchItemsInDB(val, item.id);
              }}
              autoComplete="off"
            />
            {isSearchingItem && (
              <div style={styles.loadingIndicator}>⏳</div>
            )}
            {suggestions.length > 0 && (
              <div style={styles.suggestionsContainer}>
                {suggestions.map((suggestion, idx) => (
                  <div
                    key={idx}
                    onClick={() => selectSuggestion(item.id, suggestion)}
                    style={styles.suggestionItem}
                    onMouseEnter={(e) => e.currentTarget.style.background = '#f0f7ff'}
                    onMouseLeave={(e) => e.currentTarget.style.background = 'white'}
                  >
                    <div style={styles.suggestionName}>
                      {suggestion.name}
                      {suggestion.model && (
                        <span style={{ color: '#666', fontWeight: 'normal', marginLeft: '8px' }}>
                          — {suggestion.model}
                        </span>
                      )}
                    </div>
                    <div style={styles.suggestionDetails}>
                      {suggestion.sku && <span>Артикул: {suggestion.sku} | </span>}
                      {suggestion.cost && <span>Себест: {suggestion.cost} ₽ | </span>}
                      {suggestion.price && <span>Цена: {suggestion.price} ₽</span>}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
        
        <div style={styles.mobileRow}>
          <div style={styles.mobileFieldGroup}>
            <div style={styles.mobileLabel}>Модель</div>
            <input
              style={styles.mobileInput}
              placeholder="Модель"
              value={item.model}
              onChange={(e) => updateIncomingItem(item.id, 'model', e.target.value)}
            />
          </div>
          <div style={styles.mobileFieldGroup}>
            <div style={styles.mobileLabel}>Артикул</div>
            <input
              style={styles.mobileInput}
              placeholder="Артикул"
              value={item.sku}
              onChange={(e) => updateIncomingItem(item.id, 'sku', e.target.value)}
            />
          </div>
        </div>
        
        <div style={styles.mobileRow}>
          <div style={styles.mobileFieldGroup}>
            <div style={styles.mobileLabel}>Себестоимость *</div>
            <input
              style={styles.mobileInput}
              type="number"
              step="0.01"
              placeholder="Себест."
              value={item.cost}
              onChange={(e) => updateIncomingItem(item.id, 'cost', e.target.value)}
            />
          </div>
          <div style={styles.mobileFieldGroup}>
            <div style={styles.mobileLabel}>Доп. расход</div>
            <input
              style={styles.mobileInput}
              type="number"
              step="0.01"
              placeholder="Доп. расх."
              value={item.extraCost}
              onChange={(e) => updateIncomingItem(item.id, 'extraCost', parseFloat(e.target.value) || 0)}
            />
          </div>
        </div>
        
        <div style={styles.mobileRow}>
          <div style={styles.mobileFieldGroup}>
            <div style={styles.mobileLabel}>Цена</div>
            <input
              style={styles.mobileInput}
              type="number"
              step="0.01"
              placeholder="Цена"
              value={item.price}
              onChange={(e) => updateIncomingItem(item.id, 'price', e.target.value)}
            />
          </div>
          <div style={styles.mobileFieldGroup}>
            <div style={styles.mobileLabel}>Количество</div>
            <input
              style={styles.mobileInput}
              type="number"
              placeholder="Кол-во"
              value={item.quantity}
              onChange={(e) => updateIncomingItem(item.id, 'quantity', e.target.value)}
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h2 style={styles.title}>📦 Учёт товаров (остатки)</h2>
        
        <div style={styles.stats}>
          <span style={styles.statItem}>
            <span style={styles.statLabel}>💰 Себест.:</span>
            <strong style={styles.statValue}>{totalCost.toFixed(2)} ₽</strong>
          </span>
          <span style={styles.statItem}>
            <span style={styles.statLabel}>📊 Доп. расход:</span>
            <strong style={styles.statValue}>{totalExtraCost.toFixed(2)} ₽</strong>
          </span>
          <span style={styles.statItem}>
            <span style={styles.statLabel}>💵 Реализация:</span>
            <strong style={styles.statValue}>{totalPrice.toFixed(2)} ₽</strong>
          </span>
          <span style={styles.statItem}>
            <span style={styles.statLabel}>📈 Кэф:</span>
            <strong style={styles.statValue}>⨯{coefficient}</strong>
          </span>
        </div>
      </div>

      {incomingHistory.length > 0 && (
        <div style={styles.historyBlock}>
          <span style={styles.historyLabel}>📦 Приходы:</span>
          {incomingHistory.slice(0, 10).map(incoming => {
            // 🔥 Рассчитываем коэффициент для этого прихода
            let incomingCoeff = '0.00';
            if (incoming.items && incoming.items.length > 0) {
              const totalCost = incoming.items.reduce((sum, item) => {
                const cost = parseFloat(item.cost) || 0;
                const extraCost = parseFloat(item.extraCost) || 0;
                const quantity = parseInt(item.quantity) || 0;
                return sum + ((cost + extraCost) * quantity);
              }, 0);
              
              const totalPrice = incoming.items.reduce((sum, item) => {
                const price = parseFloat(item.price) || 0;
                const quantity = parseInt(item.quantity) || 0;
                return sum + (price * quantity);
              }, 0);
              
              const totalExpenses = parseFloat(incoming.total_expenses) || 0;
              const totalWithExpenses = totalCost + totalExpenses;
              
              incomingCoeff = totalWithExpenses > 0 && totalPrice > 0 
                ? (totalPrice / totalWithExpenses).toFixed(2) 
                : '0.00';
            }
            
            return (
              <div 
                key={incoming.id}
                onClick={() => editIncomingOrder(incoming.id)}
                style={styles.historyItem}
                onMouseEnter={(e) => e.currentTarget.style.background = '#bbdefb'}
                onMouseLeave={(e) => e.currentTarget.style.background = '#e3f2fd'}
              >
                <span>📦</span>
                <span>{new Date(incoming.date).toLocaleDateString()}</span>
                <span style={{ 
                  fontSize: '12px', 
                  fontWeight: 'bold',
                  color: parseFloat(incomingCoeff) >= 1 ? '#28a745' : '#dc3545'
                }}>
                 ( ⨯{incomingCoeff})
                </span>
                {/* <span style={{ fontSize: '11px', color: '#666' }}>
                  ({incoming.items?.length || 0} шт.)
                </span> */}
                <button
                  onClick={(e) => deleteIncomingOrder(incoming.id, e)}
                  style={{
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    color: '#dc3545',
                    fontSize: '12px',
                    padding: '0 4px',
                    marginLeft: '2px'
                  }}
                  title="Удалить приход"
                >
                  ✕
                </button>
              </div>
            );
          })}
        </div>
      )}

      <div style={{ marginBottom: '20px' }}>
        <button
          onClick={() => {
            if (showIncomingForm) {
              resetIncomingForm();
            } else {
              setShowIncomingForm(true);
              setEditingIncomingId(null);
            }
          }}
          style={{
            ...styles.button,
            background: showIncomingForm ? '#dc3545' : '#28a745',
            padding: '10px 24px',
            fontSize: '16px'
          }}
        >
          {showIncomingForm ? '❌ Закрыть приход' : '📥 Приход поставки'}
        </button>
        {editingIncomingId && showIncomingForm && (
          <span style={styles.editModeBadge}>
            ✏️ Редактирование прихода #{editingIncomingId}
          </span>
        )}
      </div>

      {showIncomingForm && (
        <div id="incomingForm" style={styles.incomingForm}>
          <h3 style={styles.incomingTitle}>
            {editingIncomingId ? '✏️ Редактирование прихода' : '📥 Приход поставки'}
          </h3>
          
          {/* 🔥 БЛОК СУММ ПРИХОДА */}
          <IncomingSummary />
          
          <div style={{ marginBottom: '20px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
              <h4 style={{ margin: 0 }}>📦 Товары</h4>
              <button type="button" onClick={addIncomingItem} style={styles.addButton}>
                ➕ Добавить товар
              </button>
            </div>
            
            {isMobile ? (
              <div>
                {incomingItems.map((item, index) => (
                  <MobileItemCard key={item.id} item={item} index={index} />
                ))}
              </div>
            ) : (
              <div style={styles.tableWrapper}>
                <table style={styles.table}>
                  <thead>
                    <tr>
                      <th style={styles.thTd}>Название*</th>
                      <th style={styles.thTd}>Модель</th>
                      <th style={styles.thTd}>Артикул</th>
                      <th style={styles.thTd}>Себест.*</th>
                      <th style={styles.thTd}>Доп. расход</th>
                      <th style={styles.thTd}>Цена</th>
                      <th style={styles.thTd}>Кол-во</th>
                      <th style={styles.thTd}>Действия</th>
                    </tr>
                  </thead>
                  <tbody>
                    {incomingItems.map((item) => {
                      const suggestions = searchSuggestions[item.id] || [];
                      const isSearchingItem = isSearching[item.id] || false;
                      
                      return (
                        <tr key={item.id}>
                          <td style={styles.searchCell}>
                            <div style={styles.searchInputWrapper}>
                              <input
                                style={{
                                  ...styles.input,
                                  width: '100%',
                                  boxSizing: 'border-box',
                                  paddingRight: isSearchingItem ? '30px' : '12px'
                                }}
                                placeholder="Название"
                                value={item.name}
                                onChange={(e) => {
                                  const val = e.target.value;
                                  updateIncomingItem(item.id, 'name', val);
                                  searchItemsInDB(val, item.id);
                                }}
                                autoComplete="off"
                              />
                              {isSearchingItem && (
                                <div style={styles.loadingIndicator}>⏳</div>
                              )}
                              {suggestions.length > 0 && (
                                <div style={styles.suggestionsContainer}>
                                  {suggestions.map((suggestion, idx) => (
                                    <div
                                      key={idx}
                                      onClick={() => selectSuggestion(item.id, suggestion)}
                                      style={styles.suggestionItem}
                                      onMouseEnter={(e) => e.currentTarget.style.background = '#f0f7ff'}
                                      onMouseLeave={(e) => e.currentTarget.style.background = 'white'}
                                    >
                                      <div style={styles.suggestionName}>
                                        {suggestion.name}
                                        {suggestion.model && (
                                          <span style={{ color: '#666', fontWeight: 'normal', marginLeft: '8px' }}>
                                            — {suggestion.model}
                                          </span>
                                        )}
                                      </div>
                                      <div style={styles.suggestionDetails}>
                                        {suggestion.sku && <span>Артикул: {suggestion.sku} | </span>}
                                        {suggestion.cost && <span>Себест: {suggestion.cost} ₽ | </span>}
                                        {suggestion.price && <span>Цена: {suggestion.price} ₽</span>}
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          </td>
                          <td style={styles.thTd}>
                            <input
                              style={styles.input}
                              placeholder="Модель"
                              value={item.model}
                              onChange={(e) => updateIncomingItem(item.id, 'model', e.target.value)}
                            />
                          </td>
                          <td style={styles.thTd}>
                            <input
                              style={styles.input}
                              placeholder="Артикул"
                              value={item.sku}
                              onChange={(e) => updateIncomingItem(item.id, 'sku', e.target.value)}
                            />
                          </td>
                          <td style={styles.thTd}>
                            <input
                              style={{...styles.input, width: '90px'}}
                              type="number"
                              step="0.01"
                              placeholder="Себест."
                              value={item.cost}
                              onChange={(e) => updateIncomingItem(item.id, 'cost', e.target.value)}
                            />
                          </td>
                          <td style={styles.thTd}>
                            <input
                              style={{...styles.input, width: '70px'}}
                              type="number"
                              step="0.01"
                              placeholder="Доп. расх."
                              value={item.extraCost}
                              onChange={(e) => updateIncomingItem(item.id, 'extraCost', parseFloat(e.target.value) || 0)}
                            />
                          </td>
                          <td style={styles.thTd}>
                            <input
                              style={{...styles.input, width: '90px'}}
                              type="number"
                              step="0.01"
                              placeholder="Цена"
                              value={item.price}
                              onChange={(e) => updateIncomingItem(item.id, 'price', e.target.value)}
                            />
                          </td>
                          <td style={styles.thTd}>
                            <input
                              style={{...styles.input, width: '50px'}}
                              type="number"
                              placeholder="Кол-во"
                              value={item.quantity}
                              onChange={(e) => updateIncomingItem(item.id, 'quantity', e.target.value)}
                            />
                          </td>
                          <td style={styles.thTd}>
                            <button
                              type="button"
                              style={styles.dangerButton}
                              onClick={() => removeIncomingItem(item.id)}
                            >
                              🗑️
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
          </div>

          <div style={styles.expensesBlock}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
              <h4 style={{ margin: 0 }}>💳 Сопутствующие расходы</h4>
              <button type="button" onClick={addExpense} style={styles.addButton}>
                ➕ Добавить расход
              </button>
            </div>
            
            <div style={styles.tableWrapper}>
              <table style={styles.table}>
                <thead>
                  <tr>
                    <th style={styles.thTd}>Наименование</th>
                    <th style={styles.thTd}>Сумма</th>
                    <th style={styles.thTd}>Действия</th>
                  </tr>
                </thead>
                <tbody>
                  {expenses.map((exp) => (
                    <tr key={exp.id}>
                      <td style={styles.thTd}>
                        <input
                          style={styles.input}
                          placeholder="Наименование расхода"
                          value={exp.name}
                          onChange={(e) => updateExpense(exp.id, 'name', e.target.value)}
                        />
                      </td>
                      <td style={styles.thTd}>
                        <input
                          style={{...styles.input, width: '120px'}}
                          type="number"
                          step="0.01"
                          placeholder="Сумма"
                          value={exp.amount}
                          onChange={(e) => updateExpense(exp.id, 'amount', e.target.value)}
                        />
                      </td>
                      <td style={styles.thTd}>
                        <button
                          type="button"
                          style={styles.dangerButton}
                          onClick={() => removeExpense(exp.id)}
                        >
                          🗑️
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            
            <div style={styles.expensesTotal}>
              <span>💰 Итого расходов: <strong style={{ color: '#dc3545' }}>{totalExpenses.toFixed(2)} ₽</strong></span>
            </div>
          </div>

          <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
            <button
              type="button"
              onClick={resetIncomingForm}
              style={{ ...styles.dangerButton, padding: '10px 20px', fontSize: '16px' }}
            >
              Отмена
            </button>
            <button
              type="button"
              onClick={handleIncomingSubmit}
              disabled={loading}
              style={{ ...styles.button, padding: '10px 30px', fontSize: '16px' }}
            >
              {loading ? '⏳ Сохранение...' : (editingIncomingId ? '💾 Обновить приход' : '📥 Поставить на приход')}
            </button>
          </div>
        </div>
      )}

      {/* Остальной код (форма добавления товара, таблица товаров) остаётся без изменений */}
      <form style={styles.form} onSubmit={handleSubmit}>
        <div style={styles.formRow}>
          <input style={styles.input} name="name" placeholder="Название товара*" value={form.name} onChange={handleChange} required />
          <input style={styles.input} name="model" placeholder="Модель" value={form.model} onChange={handleChange} />
          <input style={styles.input} name="sku" placeholder="Артикул" value={form.sku} onChange={handleChange} />
          <input style={styles.input} name="cost" type="number" step="0.01" placeholder="Себестоимость*" value={form.cost} onChange={handleChange} required />
          <input style={styles.input} name="price" type="number" step="0.01" placeholder="Цена реализации*" value={form.price} onChange={handleChange} required />
          <input style={styles.input} name="quantity" type="number" placeholder="Количество" value={form.quantity} onChange={handleChange} />
        </div>
        <div>
          <button style={styles.button} type="submit" disabled={loading}>
            {loading ? '⏳ Сохранение...' : (editId ? '💾 Сохранить' : '➕ Добавить')}
          </button>
          {editId && (
            <button 
              style={{...styles.dangerButton, background:'#6c757d', marginLeft: '10px'}} 
              onClick={() => { 
                setEditId(null); 
                setForm({ name: '', model: '', sku: '', cost: '', price: '', quantity: 1 }); 
              }}
            >
              Отмена
            </button>
          )}
        </div>
      </form>

      <div style={styles.searchWrapper}>
        <div style={{ flex: 1, position: 'relative' }}>
          <input
            type="text"
            placeholder="🔍 Поиск по названию, модели или артикулу..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={styles.searchInput}
          />
          {searchTerm && (
            <button onClick={clearSearch} style={styles.clearButton}>
              ✕
            </button>
          )}
        </div>
        {searchTerm && (
          <span style={{ fontSize: '14px', color: '#666', whiteSpace: 'nowrap' }}>
            Найдено: {filteredItems.length} из {items.length}
          </span>
        )}
      </div>

      <div style={styles.tableWrapper}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.thTd}>Название</th>
              <th style={styles.thTd}>Модель</th>
              <th style={styles.thTd}>Артикул</th>
              <th style={styles.thTd}>Себест.</th>
              <th style={styles.thTd}>Доп. расход</th>
              <th style={styles.thTd}>Цена</th>
              <th style={styles.thTd}>Кол-во</th>
              <th style={styles.thTd}>Кэф</th>
              <th style={styles.thTd}>Действия</th>
            </tr>
          </thead>
          <tbody>
            {filteredItems.map(item => {
              const totalItemCost = parseFloat(item.cost) || 0;
              const extraCost = parseFloat(item.extra_cost) || 0;
              const totalWithExtra = totalItemCost + extraCost;
              const itemCoefficient = totalWithExtra > 0 ? (parseFloat(item.price) / totalWithExtra).toFixed(2) : '0.00';
              const isProfitable = itemCoefficient >= 1;
              
              return (
                <tr key={item.id}>
                  <td style={styles.thTd}>{item.name}</td>
                  <td style={styles.thTd}>{item.model || '-'}</td>
                  <td style={styles.thTd}>{item.sku || '-'}</td>
                  <td style={styles.thTd}>{totalItemCost.toFixed(2)} ₽</td>
                  <td style={styles.thTd}>{extraCost > 0 ? extraCost.toFixed(2) + ' ₽' : '-'}</td>
                  <td style={styles.thTd}>{parseFloat(item.price).toFixed(2)} ₽</td>
                  <td style={styles.thTd}>{item.quantity}</td>
                  <td style={styles.thTd}>
                    <span style={{
                      ...styles.coefficient,
                      color: isProfitable ? '#28a745' : '#dc3545'
                    }}>
                      ⨯{itemCoefficient}
                    </span>
                  </td>
                  <td style={styles.thTd}>
                    <button style={styles.editButton} onClick={() => handleEdit(item)}>✏️</button>
                    <button style={styles.dangerButton} onClick={() => handleDelete(item.id)}>🗑️</button>
                  </td>
                </tr>
              );
            })}
            {filteredItems.length === 0 && (
              <tr>
                <td colSpan="9" style={{textAlign: 'center', padding: '20px'}}>
                  {searchTerm ? '🔍 Ничего не найдено' : '📭 Нет товаров на складе'}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
// --- Страница 2: Выезды инженеров (с синхронизацией выплат через БД) ---
const JobsPage = ({ items, setItems, jobs, setJobs, onLoadJobs, onLoadItems }) => {
  // ============================================================
  //  СОСТОЯНИЯ
  // ============================================================
  const [form, setForm] = useState({
    engineer: '',
    model: '',
    date: new Date().toISOString().slice(0, 10),
    address: '',
    photo: ''
  });
  const [workItems, setWorkItems] = useState([{ id: Date.now(), name: '', price: '' }]);
  const [selectedStockItems, setSelectedStockItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // --- Состояние для выплат (из БД) ---
  const [payments, setPayments] = useState({
    sysAdmin: { paid: 0 },
    nds: { paid: 0 },
    return: { paid: 0 }
  });
  const [paymentInputs, setPaymentInputs] = useState({
    sysAdmin: '',
    nds: '',
    return: ''
  });
  const [paymentsLoading, setPaymentsLoading] = useState(true);

  // ============================================================
  //  ЗАГРУЗКА ВЫПЛАТ ИЗ БД
  // ============================================================
  const loadPayments = async () => {
    setPaymentsLoading(true);
    try {
      const response = await fetch(`${API_URL}/payments.php`);
      const data = await response.json();
      if (!data.error) {
        setPayments({
          sysAdmin: { paid: data.sysAdmin?.paid || 0 },
          nds: { paid: data.nds?.paid || 0 },
          return: { paid: data.return?.paid || 0 }
        });
      }
    } catch (error) {
      console.error('Ошибка загрузки выплат:', error);
    } finally {
      setPaymentsLoading(false);
    }
  };

  // ============================================================
  //  СОХРАНЕНИЕ ВЫПЛАТЫ В БД
  // ============================================================
  const savePayment = async (type, amount) => {
    try {
      const response = await fetch(`${API_URL}/payments.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ type, amount })
      });
      const result = await response.json();
      if (result.success && result.data) {
        setPayments({
          sysAdmin: { paid: result.data.sysAdmin?.paid || 0 },
          nds: { paid: result.data.nds?.paid || 0 },
          return: { paid: result.data.return?.paid || 0 }
        });
        return true;
      } else {
        alert('❌ Ошибка при сохранении выплаты');
        return false;
      }
    } catch (error) {
      console.error('Ошибка сохранения выплаты:', error);
      alert('❌ Ошибка при сохранении выплаты');
      return false;
    }
  };

  // ============================================================
  //  ЗАГРУЗКА ПРИ МОНТИРОВАНИИ
  // ============================================================
  useEffect(() => {
    loadPayments();
  }, []);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // ============================================================
  //  РАСЧЁТЫ
  // ============================================================
  const calculateCurrentSum = () => {
    const worksSum = workItems.reduce((sum, w) => sum + (parseFloat(w.price) || 0), 0);
    const stockSum = selectedStockItems.reduce((sum, s) => sum + (s.price * s.quantity), 0);
    return worksSum + stockSum;
  };

  const calculateFinalSum = (totalSum, worksSum) => {
    const sysAdmin = totalSum * 0.05;
    const nds = totalSum * 0.06;
    const engineerShare = worksSum * 0.6;
    const afterFirstDeductions = totalSum - sysAdmin - nds - engineerShare;
    const returnAmount = afterFirstDeductions * 0.15;
    const finalSum = afterFirstDeductions - returnAmount;

    return {
      sysAdmin,
      nds,
      engineerShare,
      returnAmount,
      finalSum,
      afterFirstDeductions
    };
  };

  const calculateJobFinalSum = (job) => {
    const total = job.totalSum || 0;
    const worksTotal = job.works?.reduce((s, w) => s + (parseFloat(w.price) || 0), 0) || 0;
    const worksSum = worksTotal;

    const sysAdmin = total * 0.05;
    const nds = total * 0.06;
    const engineerShare = worksSum * 0.6;
    const afterFirstDeductions = total - sysAdmin - nds - engineerShare;
    const returnAmount = afterFirstDeductions * 0.15;
    const finalSum = afterFirstDeductions - returnAmount;

    return {
      total,
      worksSum,
      sysAdmin,
      nds,
      engineerShare,
      returnAmount,
      finalSum,
      afterFirstDeductions
    };
  };

  const renderCalculationDetails = (job) => {
    const calc = calculateJobFinalSum(job);
    return (
      <div style={{
        fontSize: '11px',
        marginTop: '4px',
        padding: '4px 8px',
        background: '#f8f9fa',
        borderRadius: '4px',
        border: '1px solid #e9ecef'
      }}>
        <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: '1px 10px' }}>
          <span>💰 {calc.total.toFixed(2)} ₽</span>
          <span style={{ color: '#dc3545' }}>-5% сис.админ - {calc.sysAdmin.toFixed(2)}</span>
          <span style={{ color: '#dc3545' }}>-6% НДС - {calc.nds.toFixed(2)}</span>
          <span style={{ color: '#dc3545' }}>-60% инженеру - {calc.engineerShare.toFixed(2)}</span>
          <span style={{
            borderTop: '1px solid #007bff',
            gridColumn: isMobile ? '1' : '1 / -1',
            textAlign: 'center',
            fontWeight: 'bold',
            color: '#007bff',
            paddingTop: '4px'
          }}>
          </span>
          <span style={{ color: 'rgb(37, 155, 229)' }}>🔄 Сумма после вычетов: {calc.afterFirstDeductions.toFixed(2)}</span>
          <span style={{ color: 'rgb(37, 155, 229)' }}>-15% возврат - {calc.returnAmount.toFixed(2)}</span>
          <span style={{
            borderTop: '2px solid #007bff',
            gridColumn: isMobile ? '1' : '1 / -1',
            textAlign: 'center',
            fontWeight: 'bold',
            color: '#007bff',
            paddingTop: '4px'
          }}>
            💳 ИТОГО: {calc.finalSum.toFixed(2)} ₽
          </span>
        </div>
      </div>
    );
  };

  // ============================================================
  //  ОТПРАВКА ФОРМЫ
  // ============================================================
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.engineer || !form.model || !form.date || !form.address) {
      alert('Заполните обязательные поля: Кто поехал, модель, дата, адрес');
      return;
    }

    const validWorks = workItems.filter(w => w.name.trim());

    if (validWorks.length === 0 && selectedStockItems.length === 0) {
      alert('Добавьте хотя бы одну работу или деталь со склада!');
      return;
    }

    setLoading(true);

    try {
      const totalSum = calculateCurrentSum();
      const worksSum = workItems.reduce((sum, w) => sum + (parseFloat(w.price) || 0), 0);
      const partsSum = selectedStockItems.reduce((sum, s) => sum + (s.price * s.quantity), 0);

      const newJob = {
        who: form.engineer,
        date: form.date,
        address: form.address,
        model: form.model,
        photo: form.photo || '',
        works: validWorks.map(w => ({
          name: w.name,
          price: parseFloat(w.price) || 0
        })),
        parts: selectedStockItems.map(s => ({
          id: s.id,
          name: s.name,
          price: s.price,
          quantity: s.quantity
        })),
        participants: [],
        total_works: worksSum,
        total_parts: partsSum,
        total_sum: totalSum,
        sys_admin_sum: 0,
        final_sum: totalSum
      };

      const response = await fetch(`${API_URL}/miniapp_api.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(newJob)
      });

      const result = await response.json();

      if (result.success) {
        await onLoadItems();
        await onLoadJobs();

        setForm({
          engineer: '',
          model: '',
          date: new Date().toISOString().slice(0, 10),
          address: '',
          photo: ''
        });
        setWorkItems([{ id: Date.now(), name: '', price: '' }]);
        setSelectedStockItems([]);

        const finalCalc = calculateFinalSum(totalSum, worksSum);
        alert(`✅ Выезд сохранён!\n\n` +
          `💰 Общая сумма: ${totalSum.toFixed(2)} ₽\n` +
          `🔩 Запчасти: ${partsSum.toFixed(2)} ₽\n` +
          `💎 Работы: ${worksSum.toFixed(2)} ₽\n` +
          `👥 60% инженеру: ${(worksSum / 2).toFixed(2)} ₽\n\n` +
          `📊 После вычетов:\n` +
          `👨‍💻 Сис.админ (5% от общ.): -${finalCalc.sysAdmin.toFixed(2)} ₽\n` +
          `📊 НДС (6% от общ.): -${finalCalc.nds.toFixed(2)} ₽\n` +
          `👥 Оплата (60% от работ): -${finalCalc.engineerShare.toFixed(2)} ₽\n` +
          `🔄 Сумма после вычетов: ${finalCalc.afterFirstDeductions.toFixed(2)} ₽\n` +
          `🔄 Возврат (15% от суммы после вычетов): -${finalCalc.returnAmount.toFixed(2)} ₽\n` +
          `💳 ИТОГО: ${finalCalc.finalSum.toFixed(2)} ₽`);
      } else {
        alert(`❌ Ошибка: ${result.error || 'Неизвестная ошибка'}`);
      }
    } catch (error) {
      console.error('Ошибка сохранения выезда:', error);
      alert('Ошибка при сохранении выезда');
    } finally {
      setLoading(false);
    }
  };

  // ============================================================
  //  РАБОТА С ТОВАРАМИ
  // ============================================================
  const addWorkItem = () => {
    setWorkItems([...workItems, { id: Date.now(), name: '', price: '' }]);
  };

  const removeWorkItem = (id) => {
    if (workItems.length === 1) {
      alert('Должна быть хотя бы одна работа');
      return;
    }
    setWorkItems(workItems.filter(w => w.id !== id));
  };

  const updateWorkItem = (id, field, value) => {
    setWorkItems(workItems.map(w => w.id === id ? { ...w, [field]: value } : w));
  };

  const addStockItem = (itemId) => {
    const item = items.find(i => i.id === parseInt(itemId));
    if (!item) return;
    if (item.quantity <= 0) {
      alert('Товара нет в наличии!');
      return;
    }
    const existing = selectedStockItems.find(s => s.id === item.id);
    if (existing) {
      if (existing.quantity + 1 > item.quantity) {
        alert(`Нельзя добавить больше, чем есть на складе (${item.quantity} шт.)`);
        return;
      }
      setSelectedStockItems(selectedStockItems.map(s =>
        s.id === item.id ? { ...s, quantity: s.quantity + 1 } : s
      ));
    } else {
      setSelectedStockItems([...selectedStockItems, {
        id: item.id,
        name: item.name,
        price: item.price,
        quantity: 1
      }]);
    }
  };

  const removeStockItem = (id) => {
    setSelectedStockItems(selectedStockItems.filter(s => s.id !== id));
  };

  const updateStockQuantity = (id, newQty) => {
    const item = items.find(i => i.id === id);
    if (!item) return;
    if (newQty > item.quantity) {
      alert(`На складе только ${item.quantity} шт.`);
      return;
    }
    if (newQty <= 0) {
      removeStockItem(id);
    } else {
      setSelectedStockItems(selectedStockItems.map(s =>
        s.id === id ? { ...s, quantity: newQty } : s
      ));
    }
  };

  // ============================================================
  //  ОБРАБОТЧИК ВЫПЛАТ
  // ============================================================
  const handlePayment = async (type) => {
    const amount = parseFloat(paymentInputs[type]);
    if (!isNaN(amount) && amount > 0) {
      const success = await savePayment(type, amount);
      if (success) {
        setPaymentInputs({ ...paymentInputs, [type]: '' });
      }
    }
  };

  // ============================================================
  //  РАСЧЁТЫ ДЛЯ ОТОБРАЖЕНИЯ
  // ============================================================
  const totalJobsSum = jobs.reduce((sum, job) => {
    const worksTotal = job.works?.reduce((s, w) => s + (parseFloat(w.price) || 0), 0) || 0;
    const partsTotal = job.parts?.reduce((s, p) => s + (parseFloat(p.price) || 0) * (parseInt(p.quantity) || 1), 0) || 0;
    return sum + worksTotal + partsTotal;
  }, 0);

  const totalWorksSum = jobs.reduce((sum, job) => {
    const worksTotal = job.works?.reduce((s, w) => s + (parseFloat(w.price) || 0), 0) || 0;
    return sum + worksTotal;
  }, 0);

  const totalPartsSum = jobs.reduce((sum, job) => {
    const partsTotal = job.parts?.reduce((s, p) => s + (parseFloat(p.price) || 0) * (parseInt(p.quantity) || 1), 0) || 0;
    return sum + partsTotal;
  }, 0);

  const totalSysAdmin = totalJobsSum * 0.05;
  const totalNds = totalJobsSum * 0.06;
  const totalEngineerShare = totalWorksSum * 0.6;
  const totalAfterFirstDeductions = totalJobsSum - totalSysAdmin - totalNds - totalEngineerShare;
  const totalReturn = totalAfterFirstDeductions * 0.15;
  const totalFinalSum = totalAfterFirstDeductions - totalReturn;

  const currentSum = calculateCurrentSum();
  const currentWorksSum = workItems.reduce((sum, w) => sum + (parseFloat(w.price) || 0), 0);
  const currentPartsSum = selectedStockItems.reduce((sum, s) => sum + (s.price * s.quantity), 0);

  // ============================================================
  //  РЕНДЕРИНГ
  // ============================================================
  return (
    <div>
      {/* ===== ЗАГОЛОВОК СТАТИСТИКИ ===== */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        marginBottom: '20px',
        gap: '15px'
      }}>
        <h2>Продажи | Выезды</h2>
        <div style={{
          ...styles.stats,
          padding: '15px 25px',
          fontSize: '16px',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          borderRadius: '12px',
          minWidth: isMobile ? '100%' : '350px',
          boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)',
          boxSizing: 'border-box'
        }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', width: '100%' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid rgba(255,255,255,0.2)', paddingBottom: '6px' }}>
              <span>💰 Общая сумма выездов:</span>
              <strong style={{ fontSize: '18px' }}>{totalJobsSum.toFixed(2)} ₽</strong>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', opacity: 0.9 }}>
              <span>💎 Работы:</span>
              <span>{totalWorksSum.toFixed(2)} ₽</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', opacity: 0.9, borderBottom: '1px solid rgba(255,255,255,0.2)', paddingBottom: '6px' }}>
              <span>🔩 Запчасти:</span>
              <span>{totalPartsSum.toFixed(2)} ₽</span>
            </div>

            {/* 👨‍💻 Сис.админ с выплатами */}
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              fontSize: '13px',
              opacity: 0.9,
              flexWrap: 'wrap',
              gap: '5px',
              padding: '4px 0',
              borderBottom: '1px solid rgba(255,255,255,0.15)'
            }}>
              <span>👨‍💻 Сис.админ (5% от общ.):</span>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                <span style={{ color: '#ffd700' }}>-{totalSysAdmin.toFixed(2)} ₽</span>
                {payments.sysAdmin?.paid > 0 && (
                  <span style={{ color: '#90EE90', fontSize: '12px', fontWeight: 'bold' }}>
                    ✅ {payments.sysAdmin.paid.toFixed(2)} ₽
                  </span>
                )}
                <input
                  type="number"
                  step="0.01"
                  placeholder="Сумма"
                  value={paymentInputs.sysAdmin}
                  onChange={(e) => setPaymentInputs({ ...paymentInputs, sysAdmin: e.target.value })}
                  style={{
                    width: '80px',
                    padding: '2px 6px',
                    borderRadius: '4px',
                    border: '1px solid rgba(255,255,255,0.3)',
                    background: 'rgba(255,255,255,0.15)',
                    color: 'white',
                    fontSize: '12px'
                  }}
                />
                <button
                  onClick={() => handlePayment('sysAdmin')}
                  style={{
                    padding: '2px 10px',
                    borderRadius: '4px',
                    border: 'none',
                    background: '#28a745',
                    color: 'white',
                    fontSize: '11px',
                    cursor: 'pointer'
                  }}
                >
                  ✅ Выплачено
                </button>
              </div>
            </div>

            {/* 📊 НДС с выплатами */}
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              fontSize: '13px',
              opacity: 0.9,
              flexWrap: 'wrap',
              gap: '5px',
              padding: '4px 0',
              borderBottom: '1px solid rgba(255,255,255,0.15)'
            }}>
              <span>📊 НДС (6% от общ.):</span>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                <span style={{ color: '#ffd700' }}>-{totalNds.toFixed(2)} ₽</span>
                {payments.nds?.paid > 0 && (
                  <span style={{ color: '#90EE90', fontSize: '12px', fontWeight: 'bold' }}>
                    ✅ {payments.nds.paid.toFixed(2)} ₽
                  </span>
                )}
                <input
                  type="number"
                  step="0.01"
                  placeholder="Сумма"
                  value={paymentInputs.nds}
                  onChange={(e) => setPaymentInputs({ ...paymentInputs, nds: e.target.value })}
                  style={{
                    width: '80px',
                    padding: '2px 6px',
                    borderRadius: '4px',
                    border: '1px solid rgba(255,255,255,0.3)',
                    background: 'rgba(255,255,255,0.15)',
                    color: 'white',
                    fontSize: '12px'
                  }}
                />
                <button
                  onClick={() => handlePayment('nds')}
                  style={{
                    padding: '2px 10px',
                    borderRadius: '4px',
                    border: 'none',
                    background: '#28a745',
                    color: 'white',
                    fontSize: '11px',
                    cursor: 'pointer'
                  }}
                >
                  ✅ Выплачено
                </button>
              </div>
            </div>

            {/* 👥 Оплата инженеру */}
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              fontSize: '13px',
              opacity: 0.9,
              borderBottom: '1px solid rgba(255,255,255,0.2)',
              paddingBottom: '6px'
            }}>
              <span>👥 Оплата инженеру (60% от работ):</span>
              <span style={{ color: '#ffd700' }}>-{totalEngineerShare.toFixed(2)} ₽</span>
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', opacity: 0.9, borderBottom: '1px solid rgba(255,255,255,0.2)', paddingBottom: '6px' }}>
              <span>🔄 Сумма после вычетов:</span>
              <span style={{ color: '#90EE90' }}>{totalAfterFirstDeductions.toFixed(2)} ₽</span>
            </div>

            {/* 🔄 Возврат с выплатами */}
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              fontSize: '13px',
              opacity: 0.9,
              flexWrap: 'wrap',
              gap: '5px',
              padding: '4px 0',
              borderBottom: '1px solid rgba(255,255,255,0.15)'
            }}>
              <span>🔄 Возврат (15% от суммы после вычетов):</span>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                <span style={{ color: '#ffd700' }}>-{totalReturn.toFixed(2)} ₽</span>
                {payments.return?.paid > 0 && (
                  <span style={{ color: '#90EE90', fontSize: '12px', fontWeight: 'bold' }}>
                    ✅ {payments.return.paid.toFixed(2)} ₽
                  </span>
                )}
                <input
                  type="number"
                  step="0.01"
                  placeholder="Сумма"
                  value={paymentInputs.return}
                  onChange={(e) => setPaymentInputs({ ...paymentInputs, return: e.target.value })}
                  style={{
                    width: '80px',
                    padding: '2px 6px',
                    borderRadius: '4px',
                    border: '1px solid rgba(255,255,255,0.3)',
                    background: 'rgba(255,255,255,0.15)',
                    color: 'white',
                    fontSize: '12px'
                  }}
                />
                <button
                  onClick={() => handlePayment('return')}
                  style={{
                    padding: '2px 10px',
                    borderRadius: '4px',
                    border: 'none',
                    background: '#28a745',
                    color: 'white',
                    fontSize: '11px',
                    cursor: 'pointer'
                  }}
                >
                  ✅ Выплачено
                </button>
              </div>
            </div>

            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              borderTop: '2px solid rgba(255,255,255,0.3)',
              paddingTop: '6px',
              marginTop: '4px',
              fontSize: '17px',
              fontWeight: 'bold'
            }}>
              <span>💳 ИТОГО:</span>
              <span style={{ color: '#ffd700' }}>{totalFinalSum.toFixed(2)} ₽</span>
            </div>
          </div>
        </div>
      </div>

      {/* ===== ФОРМА СОЗДАНИЯ ВЫЕЗДА ===== */}
      <form onSubmit={handleSubmit} style={styles.form}>
        <div style={{
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          padding: '16px',
          borderRadius: '12px',
          marginBottom: '20px'
        }}>
          <div style={{ fontSize: '13px', opacity: 0.9, marginBottom: '6px' }}>💰 СУММА ТЕКУЩЕГО ВЫЕЗДА</div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '20px', fontWeight: 'bold' }}>
            <span>💎 Общая сумма:</span>
            <span style={{ color: '#ffd700' }}>{currentSum.toFixed(2)} ₽</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px', opacity: 0.9, marginTop: '4px' }}>
            <span>📝 Работы: {currentWorksSum.toFixed(2)} ₽</span>
            <span>🔩 Запчасти: {currentPartsSum.toFixed(2)} ₽</span>
          </div>
        </div>

        <div style={styles.formRow}>
          <input
            style={styles.input}
            name="engineer"
            placeholder="Кто поехал*"
            value={form.engineer}
            onChange={(e) => setForm({ ...form, engineer: e.target.value })}
            required
          />
          <input
            style={styles.input}
            name="model"
            placeholder="Какая модель*"
            value={form.model}
            onChange={(e) => setForm({ ...form, model: e.target.value })}
            required
          />
          <input
            style={styles.input}
            name="date"
            type="date"
            value={form.date}
            onChange={(e) => setForm({ ...form, date: e.target.value })}
            required
          />
          <input
            style={styles.input}
            name="address"
            placeholder="Адрес*"
            value={form.address}
            onChange={(e) => setForm({ ...form, address: e.target.value })}
            required
          />
        </div>

        <div>
          <label><strong>📝 Что сделал (работы/услуги):</strong></label>
          {workItems.map((item) => (
            <div
              key={item.id}
              className="work-item-mobile"
              style={isMobile ? { ...styles.workItem, flexDirection: 'column', alignItems: 'stretch' } : styles.workItem}
            >
              <input
                style={{ ...styles.input, flex: 2, width: isMobile ? '100%' : 'auto' }}
                placeholder="Наименование работы"
                value={item.name}
                onChange={(e) => updateWorkItem(item.id, 'name', e.target.value)}
              />
              <input
                style={{ ...styles.input, flex: 1, width: isMobile ? '100%' : 'auto', maxWidth: isMobile ? '100%' : '120px' }}
                type="number"
                step="0.01"
                placeholder="Цена"
                value={item.price}
                onChange={(e) => updateWorkItem(item.id, 'price', e.target.value)}
              />
              <button
                type="button"
                style={styles.dangerButton}
                onClick={() => removeWorkItem(item.id)}
              >
                🗑️
              </button>
            </div>
          ))}
          <button type="button" style={styles.addButton} onClick={addWorkItem}>
            ➕ Добавить работу
          </button>
        </div>

        <div>
          <label><strong>📦 Выбрать детали со склада:</strong></label>
          <select
            style={{ ...styles.input, width: '100%', marginBottom: '10px' }}
            onChange={(e) => addStockItem(e.target.value)}
            value=""
          >
            <option value="">-- Выберите деталь --</option>
            {items.filter(i => i.quantity > 0).map(item => (
              <option key={item.id} value={item.id}>
                {item.name} (остаток: {item.quantity}, цена: {item.price}₽)
              </option>
            ))}
          </select>

          {selectedStockItems.length > 0 && (
            <div style={{ marginTop: '10px' }}>
              {selectedStockItems.map(s => (
                <div
                  key={s.id}
                  style={{
                    background: '#e9ecef',
                    padding: isMobile ? '12px' : '8px 12px',
                    borderRadius: '6px',
                    marginBottom: '8px',
                    display: 'flex',
                    flexDirection: isMobile ? 'column' : 'row',
                    alignItems: isMobile ? 'stretch' : 'center',
                    gap: isMobile ? '8px' : '10px'
                  }}
                >
                  <span style={{ flex: 2, fontWeight: '500' }}>{s.name}</span>

                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span style={{ fontSize: '14px', color: '#666' }}>Кол-во:</span>
                    <input
                      type="number"
                      min="1"
                      max={items.find(i => i.id === s.id)?.quantity}
                      value={s.quantity}
                      onChange={(e) => updateStockQuantity(s.id, parseInt(e.target.value) || 1)}
                      style={{
                        width: isMobile ? '70px' : '60px',
                        padding: '6px',
                        borderRadius: '4px',
                        border: '1px solid #ccc',
                        fontSize: '14px',
                        textAlign: 'center'
                      }}
                    />
                  </div>

                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span style={{ fontSize: '14px', color: '#666' }}>Цена:</span>
                    <span style={{ fontWeight: 'bold' }}>{s.price} ₽/шт</span>
                  </div>

                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span style={{ fontSize: '14px', color: '#666' }}>Сумма:</span>
                    <span style={{ fontWeight: 'bold', color: '#007bff' }}>
                      {(s.price * s.quantity).toFixed(2)} ₽
                    </span>
                  </div>

                  <button
                    type="button"
                    style={{ ...styles.dangerButton, marginRight: 0 }}
                    onClick={() => removeStockItem(s.id)}
                  >
                    🗑️
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>

        <div style={styles.formRow}>
          <input
            style={styles.input}
            name="photo"
            placeholder="Ссылка на фото (не обязательно)"
            value={form.photo}
            onChange={(e) => setForm({ ...form, photo: e.target.value })}
          />
        </div>

        <div style={styles.centerButton}>
          <button
            style={{ ...styles.button, backgroundColor: '#007bff', padding: '12px 30px' }}
            type="submit"
            disabled={loading}
          >
            {loading ? '⏳ Сохранение...' : '✅ Сохранить выезд и списать товар'}
          </button>
        </div>
      </form>

      {/* ===== ИСТОРИЯ ВЫЕЗДОВ ===== */}
      <h3>📋 История выездов</h3>
      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th style={styles.thTd}>Дата</th>
              <th style={styles.thTd}>Инженер</th>
              <th style={styles.thTd}>Модель</th>
              <th style={styles.thTd}>Адрес</th>
              <th style={styles.thTd}>Сделано</th>
              <th style={styles.thTd}>Сумма</th>
              <th style={styles.thTd}>Фото</th>
            </tr>
          </thead>
          <tbody>
            {jobs.map(job => {
              const worksTotal = job.works?.reduce((s, w) => s + (parseFloat(w.price) || 0), 0) || 0;
              const partsTotal = job.parts?.reduce((s, p) => s + (parseFloat(p.price) || 0) * (parseInt(p.quantity) || 1), 0) || 0;
              const totalSum = worksTotal + partsTotal;

              return (
                <tr key={job.id}>
                  <td style={styles.thTd}>{job.date}</td>
                  <td style={styles.thTd}>{job.engineer || job.who}</td>
                  <td style={styles.thTd}>{job.model}</td>
                  <td style={styles.thTd}>{job.address}</td>
                  <td style={styles.thTd}>
                    {job.works?.map((w, i) => (
                      <div key={i}>• {w.name} — {w.price}₽</div>
                    ))}
                    {job.parts?.map((p, i) => (
                      <div key={i}>📦 {p.name} x{p.quantity} — {p.price * p.quantity}₽</div>
                    ))}
                    {totalSum > 0 && renderCalculationDetails(job)}
                  </td>
                  <td style={styles.thTd}>
                    <div><strong>{totalSum.toFixed(2)} ₽</strong></div>
                    <div style={{ fontSize: '12px', color: '#666' }}>
                      💎 Работы: {worksTotal.toFixed(2)} ₽
                    </div>
                    <div style={{ fontSize: '12px', color: '#666' }}>
                      🔩 Запчасти: {partsTotal.toFixed(2)} ₽
                    </div>
                    <div style={{ fontSize: '12px', color: '#007bff', fontWeight: 'bold' }}>
                      💳 ИТОГО: {calculateJobFinalSum(job).finalSum.toFixed(2)} ₽
                    </div>
                  </td>
                  <td style={styles.thTd}>
                    {job.photo && <a href={job.photo} target="_blank" rel="noreferrer">📸 Фото</a>}
                  </td>
                </tr>
              );
            })}
            {jobs.length === 0 && (
              <tr>
                <td colSpan="7" style={{ textAlign: 'center' }}>Нет выездов</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
// ============================================================
//  СТРАНИЦА 3: Рентабельность (ПОЛНАЯ ВЕРСИЯ С ФИЛЬТРОМ)
// ============================================================
const ProfitabilityPage = ({ items: externalItems, jobs: externalJobs, setItems: setExternalItems, setJobs: setExternalJobs, onLoadItems, onLoadJobs }) => {
  const [usersData, setUsersData] = useState({
    andrey: { name: 'Андрей', profitability: 0, invested: 0, debt: 0 },
    yuriy: { name: 'Юрий', profitability: 0, invested: 0, debt: 0 }
  });
  const [activeAsset, setActiveAsset] = useState(0);
  const [history, setHistory] = useState([]);
  const [prepayments, setPrepayments] = useState([]);
  const [prepaymentsExpanded, setPrepaymentsExpanded] = useState(false);
  const [jobsExpanded, setJobsExpanded] = useState(false);
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [hasFile, setHasFile] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [items, setItemsLocal] = useState(externalItems || []);
  const [jobs, setJobsLocal] = useState(externalJobs || []);
  const [form, setForm] = useState({
    user: 'andrey',
    amount: '',
    type: 'vlivaniya',
    receiptFile: null,
    comment: '',
    prepaymentDetails: '',
    selectedItem: null
  });
  
  const [searchQuery, setSearchQuery] = useState('');
  const [showSearchResults, setShowSearchResults] = useState(false);
  
  // --- ФИЛЬТР ДЛЯ ИСТОРИИ ---
  const [filterType, setFilterType] = useState('all');
  
  const filterOptions = [
    { value: 'all', label: '📋 Все операции' },
    { value: 'common', label: '💰 Общак (все операции)' },
    { value: 'vlivaniya', label: '💵 Вливания / Возвраты' },
    { value: 'dolg', label: '📝 Долг' },
    { value: 'prepayment', label: '💳 Предоплата' },
    { value: 'dividends', label: '🎯 Дивиденды' },
    { value: 'support', label: '🤝 Поддержка' }
  ];

  const getFilteredHistory = () => {
    if (filterType === 'all') return history;
    
    switch (filterType) {
      case 'common':
        // Общак — показываем и "положил в общак", и "взял из общака"
        return history.filter(item => 
          item.operation_type === 'common' || 
          item.operation_type === 'commonOut'
        );
        
      case 'vlivaniya':
        // Вливания — показываем и "влил", и "вернул"
        return history.filter(item => 
          item.operation_type === 'vlivaniya' || 
          item.operation_type === 'vernul'
        );
        
      case 'dolg':
        // Долг — все долговые операции
        return history.filter(item => 
          item.operation_type === 'dolg'
        );
        
      case 'prepayment':
        // Предоплата
        return history.filter(item => 
          item.operation_type === 'prepayment' || 
          item.operation_type === 'prepayment_released'
        );
        
      case 'dividends':
        // Дивиденды
        return history.filter(item => 
          item.operation_type === 'dividendsOne' || 
          item.operation_type === 'dividendsAll'
        );
        
      case 'support':
        // Поддержка
        return history.filter(item => 
          item.operation_type === 'support'
        );
        
      default:
        return history;
    }
  };
  
  // ============================================================
  //  СТАТИСТИКА
  // ============================================================
  const [operationStats, setOperationStats] = useState({
    supportTotal: 0,
    commonTotal: 0,
    commonOutTotal: 0,
    prepaymentTotal: 0,
    balance: 0
  });

  useEffect(() => {
    if (externalItems) setItemsLocal(externalItems);
  }, [externalItems]);
  
  useEffect(() => {
    if (externalJobs) setJobsLocal(externalJobs);
  }, [externalJobs]);
  
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // ============================================================
  //  ЗАГРУЗКА ДАННЫХ
  // ============================================================
  const loadData = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_URL}/profitability.php`);
      const data = await response.json();
      if (!data.error) {
        setUsersData(data.usersData);
        setActiveAsset(data.activeAsset);
        setHistory(data.history || []);
        
        const prepaymentsWithItems = (data.prepayments || []).map(p => {
          if (p.details && p.details !== 'null' && p.details !== '""') {
            try {
              const itemData = JSON.parse(p.details);
              p.selectedItem = itemData;
              p.prepayment_details = p.details;
            } catch (e) {
              console.warn('Не удалось распарсить details:', e);
              p.selectedItem = null;
            }
          }
          return p;
        });
        setPrepayments(prepaymentsWithItems);
        updateOperationStats(data.history || [], prepaymentsWithItems);
      }
    } catch (error) {
      console.error('Ошибка загрузки данных:', error);
    } finally {
      setLoading(false);
    }
  };
  
  const loadItemsAndJobs = async () => {
    try {
      if (onLoadItems) {
        const itemsData = await onLoadItems();
        setItemsLocal(itemsData || []);
        if (setExternalItems) setExternalItems(itemsData || []);
      }
      if (onLoadJobs) {
        const jobsData = await onLoadJobs();
        setJobsLocal(jobsData || []);
        if (setExternalJobs) setExternalJobs(jobsData || []);
      }
    } catch (error) {
      console.error('Ошибка загрузки данных:', error);
    }
  };

  const updateOperationStats = (historyData, prepaymentsData) => {
    let supportTotal = 0;
    let commonTotal = 0;
    let commonOutTotal = 0;
    let prepaymentTotal = 0;
    
    const hist = historyData || history;
    const prep = prepaymentsData || prepayments;
    
    if (Array.isArray(hist)) {
      hist.forEach(item => {
        if (!item.cancelled) {
          const amount = Number(item.amount) || 0;
          switch (item.operation_type) {
            case 'support': supportTotal += amount; break;
            case 'common': commonTotal += amount; break;
            case 'commonOut': commonOutTotal += amount; break;
            case 'prepayment': prepaymentTotal += amount; break;
          }
        }
      });
    }
    
    if (Array.isArray(prep)) {
      prep.forEach(p => {
        prepaymentTotal += Number(p.amount) || 0;
      });
    }
    
    setOperationStats({
      supportTotal,
      commonTotal,
      commonOutTotal,
      prepaymentTotal,
      balance: commonTotal - commonOutTotal
    });
  };

  useEffect(() => {
    updateOperationStats();
  }, [history, prepayments]);

  // ============================================================
  //  РАСЧЁТЫ
  // ============================================================
  const calculateDividends = () => {
    let andreyDividends = 0;
    let yuriyDividends = 0;
    
    if (Array.isArray(history)) {
      history.forEach(item => {
        if (!item.cancelled) {
          if (item.operation_type === 'dividendsOne') {
            if (item.user_name === 'Андрей') {
              andreyDividends += Number(item.amount) || 0;
            } else if (item.user_name === 'Юрий') {
              yuriyDividends += Number(item.amount) || 0;
            }
          } else if (item.operation_type === 'dividendsAll') {
            const halfAmount = (Number(item.amount) || 0) / 2;
            andreyDividends += halfAmount;
            yuriyDividends += halfAmount;
          }
        }
      });
    }
    
    return { andreyDividends, yuriyDividends };
  };
  
  const { andreyDividends, yuriyDividends } = calculateDividends();
  
  const calculateFundSources = () => {
    const totalInvested = (usersData.andrey?.invested || 0) + (usersData.yuriy?.invested || 0);
    const totalCost = Array.isArray(items) ? items.reduce((sum, item) => sum + ((item.cost || 0) * (item.quantity || 0)), 0) : 0;
    
    let fromInvestments = 0;
    let fromTurnover = 0;
    
    if (totalCost > 0) {
      if (totalInvested >= totalCost) {
        fromInvestments = totalCost;
        fromTurnover = 0;
      } else {
        fromInvestments = totalInvested;
        fromTurnover = totalCost - totalInvested;
      }
    }
    
    return { totalInvested, totalCost, fromInvestments, fromTurnover, remainingInvestments: totalInvested - fromInvestments };
  };
  
  const fundSources = calculateFundSources();
  
  const calculatePartsCost = () => {
    let totalPartsCost = 0;
    let totalPartsPrice = 0;
    
    if (Array.isArray(jobs)) {
      jobs.forEach(job => {
        const parts = job.parts || job.selectedStockItems || [];
        parts.forEach(p => {
          const item = items.find(i => i.id === p.id);
          const quantity = parseInt(p.quantity) || 1;
          
          if (item) {
            totalPartsCost += (item.cost || 0) * quantity;
          } else {
            totalPartsCost += (parseFloat(p.price) || 0) * quantity;
          }
          totalPartsPrice += (parseFloat(p.price) || 0) * quantity;
        });
      });
    }
    
    return { totalPartsCost, totalPartsPrice, profitFromParts: totalPartsPrice - totalPartsCost };
  };
  
  const partsCostData = calculatePartsCost();
  
  const calculateJobDetails = () => {
    let totalJobsSum = 0;
    let totalWorksSum = 0;
    let totalPartsSum = 0;
    
    if (Array.isArray(jobs)) {
      jobs.forEach(job => {
        const works = job.works || job.workItems || [];
        const parts = job.parts || job.selectedStockItems || [];
        
        const worksTotal = works.reduce((s, w) => s + (parseFloat(w.price) || 0), 0);
        const partsTotal = parts.reduce((s, p) => s + ((parseFloat(p.price) || 0) * (parseInt(p.quantity) || 1)), 0);
        
        totalWorksSum += worksTotal;
        totalPartsSum += partsTotal;
        totalJobsSum += worksTotal + partsTotal;
      });
    }
    
    const sysAdmin = totalJobsSum * 0.05;
    const nds = totalJobsSum * 0.06;
    const engineerShare = totalWorksSum * 0.6;
    const afterFirstDeductions = totalJobsSum - sysAdmin - nds - engineerShare;
    const returnAmount = afterFirstDeductions * 0.15;
    const afterReturn = afterFirstDeductions - returnAmount;
    const afterPartsCost = afterReturn - partsCostData.totalPartsCost;
    
    return {
      totalJobsSum,
      totalWorksSum,
      totalPartsSum,
      sysAdmin,
      nds,
      engineerShare,
      afterFirstDeductions,
      returnAmount,
      afterReturn,
      afterPartsCost,
      finalSum: afterPartsCost,
      partsCost: partsCostData.totalPartsCost,
      partsProfit: partsCostData.profitFromParts
    };
  };
  
  const jobDetails = calculateJobDetails();

  // ============================================================
  //  РАБОТА С БД
  // ============================================================
  const uploadFile = async (file) => {
    const formData = new FormData();
    formData.append('receipt', file);
    
    try {
      const response = await fetch(`${API_URL}/upload.php`, {
        method: 'POST',
        body: formData
      });
      const result = await response.json();
      if (result.success) {
        return result.filename;
      } else {
        alert('Ошибка загрузки файла: ' + result.error);
        return null;
      }
    } catch (error) {
      console.error('Ошибка загрузки файла:', error);
      return null;
    }
  };
  
  const saveData = async (newUsersData, newActiveAsset, operation) => {
    try {
      const payload = {
        usersData: newUsersData,
        activeAsset: newActiveAsset,
        operation: {
          type: operation.type,
          userName: operation.userName,
          amount: operation.amount,
          description: operation.description,
          comment: operation.comment || '',
          receiptFile: operation.receiptFile || null,
          prepaymentDetails: operation.prepaymentDetails || ''
        }
      };
      
      console.log('📤 Отправка данных на сервер:', payload);
      
      const response = await fetch(`${API_URL}/profitability.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      const result = await response.json();
      console.log('📥 Ответ сервера:', result);
      return result.success;
    } catch (error) {
      console.error('Ошибка сохранения:', error);
      return false;
    }
  };
  
  const undoLastOperation = async () => {
    if (!window.confirm('Отменить последнюю операцию?')) return;
    
    setLoading(true);
    try {
      const response = await fetch(`${API_URL}/profitability.php`, {
        method: 'DELETE'
      });
      const result = await response.json();
      
      if (result.success && result.data) {
        setUsersData(result.data.usersData);
        setActiveAsset(result.data.activeAsset);
        await loadData();
        
        if (result.data.cancelledOperation) {
          alert(`✅ Операция отменена!\n\nОтменено: ${result.data.cancelledOperation}`);
        } else {
          alert('✅ Последняя операция отменена!');
        }
      } else if (result.error) {
        alert(result.error);
      }
    } catch (error) {
      console.error('Ошибка отмены операции:', error);
      alert('Ошибка при отмене операции');
    } finally {
      setLoading(false);
    }
  };
  
  useEffect(() => {
    loadData();
    loadItemsAndJobs();
  }, []);

  // ============================================================
  //  ОБРАБОТКА ПРЕДОПЛАТЫ
  // ============================================================
  const handlePrepaymentRelease = async (prepaymentId) => {
    if (!window.confirm('Подтвердите, что предоплата отпущена?')) return;
    
    setLoading(true);
    try {
      const prepayment = prepayments.find(p => p.id === prepaymentId);
      if (!prepayment) {
        alert('Предоплата не найдена!');
        setLoading(false);
        return;
      }
      
      console.log('🔍 НАЙДЕНА ПРЕДОПЛАТА:', prepayment);
      
      const amount = Number(prepayment.amount) || 0;
      const userName = prepayment.user_name;
      
      let selectedItem = null;
      let itemCost = 0;
      let itemId = null;
      let itemName = 'без товара';
      
      if (prepayment.details && prepayment.details !== 'null' && prepayment.details !== '""') {
        try {
          const itemData = JSON.parse(prepayment.details);
          console.log('✅ Распарсенные данные товара из details:', itemData);
          
          selectedItem = itemData;
          itemCost = Number(itemData.cost) || 0;
          itemId = itemData.id || null;
          itemName = itemData.name || 'без товара';
        } catch (e) {
          console.error('❌ Ошибка парсинга details:', e);
        }
      }
      
      if (!itemId) {
        alert('❌ Данные о товаре не найдены! Невозможно списать товар.');
        setLoading(false);
        return;
      }
      
      const sysAdmin = amount * 0.05;
      const nds = amount * 0.06;
      const afterFirstDeductions = amount - sysAdmin - nds;
      const returnAmount = afterFirstDeductions * 0.15;
      const finalSum = afterFirstDeductions - returnAmount - itemCost;
      
      let newUsersData = JSON.parse(JSON.stringify(usersData));
      let newActiveAsset = activeAsset;
      
      const userKey = userName === 'Андрей' ? 'andrey' : 'yuriy';
      const otherKey = userKey === 'andrey' ? 'yuriy' : 'andrey';
      
      const halfFinalSum = finalSum / 2;
      newUsersData[userKey].profitability += halfFinalSum;
      newUsersData[otherKey].profitability += halfFinalSum;
      newActiveAsset += finalSum;
      
      let itemSpised = false;
      if (itemId) {
        const item = items.find(i => i.id === itemId);
        if (item && item.quantity > 0) {
          const updatedItem = { 
            ...item, 
            quantity: Math.max(0, item.quantity - 1) 
          };
          
          const updateResponse = await fetch(`${API_URL}/items.php`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(updatedItem)
          });
          
          if (updateResponse.ok) {
            setItemsLocal(items.map(i => i.id === itemId ? updatedItem : i));
            if (setExternalItems) setExternalItems(items.map(i => i.id === itemId ? updatedItem : i));
            itemSpised = true;
          }
        } else {
          alert(`⚠️ Товара "${itemName}" нет на складе! Остаток: ${item?.quantity || 0}`);
          setLoading(false);
          return;
        }
      }
      
      const jobData = {
        who: userName,
        date: new Date().toISOString().slice(0, 10),
        address: 'Продажа по предоплате',
        model: itemName,
        photo: prepayment.receipt_file || '',
        works: [],
        parts: itemId && itemSpised ? [{
          id: itemId,
          name: itemName,
          price: amount,
          quantity: 1
        }] : [],
        participants: [],
        total_works: 0,
        total_parts: amount,
        total_sum: amount,
        sys_admin_sum: sysAdmin,
        final_sum: finalSum,
        is_prepayment: true
      };
      
      const jobResponse = await fetch(`${API_URL}/miniapp_api.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(jobData)
      });
      
      const jobResult = await jobResponse.json();
      
      if (jobResult.success) {
        await loadItemsAndJobs();
      }
      
      setPrepayments(prepayments.filter(p => p.id !== prepaymentId));
      
      const operation = {
        type: 'prepayment_released',
        userName: userName,
        amount: amount,
        description: `✅ Продажа по предоплате: ${amount.toFixed(2)}₽ (чистая прибыль: ${finalSum.toFixed(2)}₽)`,
        comment: `Товар: ${itemName}. Вычеты: сис.админ ${sysAdmin.toFixed(2)}₽, НДС ${nds.toFixed(2)}₽, возврат ${returnAmount.toFixed(2)}₽, себестоимость ${itemCost.toFixed(2)}₽`,
        receiptFile: prepayment.receipt_file || null,
        prepaymentDetails: JSON.stringify(selectedItem) || prepayment.details || ''
      };
      
      const saved = await saveData(newUsersData, newActiveAsset, operation);
      
      if (saved) {
        setUsersData(newUsersData);
        setActiveAsset(newActiveAsset);
        await loadData();
        await loadItemsAndJobs();
        
        const historyEntry = {
          id: Date.now(),
          created_at: new Date().toISOString(),
          user_name: userName,
          amount: amount,
          operation_type: 'prepayment_released',
          description: operation.description,
          comment: operation.comment,
          receipt_file: prepayment.receipt_file || null,
          prepayment_details: JSON.stringify(selectedItem) || prepayment.details || '',
          cancelled: 0,
          cancelled_at: null
        };
        setHistory(prev => [historyEntry, ...prev]);
        
        alert(`✅ Продажа по предоплате оформлена!\n\n` +
          `💰 Сумма: ${amount.toFixed(2)} ₽\n` +
          `📦 Товар: ${itemName}\n` +
          `📊 Себестоимость: ${itemCost.toFixed(2)} ₽\n` +
          `👨‍💻 Сис.админ (5%): -${sysAdmin.toFixed(2)} ₽\n` +
          `📊 НДС (6%): -${nds.toFixed(2)} ₽\n` +
          `🔄 Возврат (15%): -${returnAmount.toFixed(2)} ₽\n` +
          `💳 Чистая прибыль: +${finalSum.toFixed(2)} ₽`);
      } else {
        alert('❌ Ошибка при сохранении операции');
      }
    } catch (error) {
      console.error('❌ Ошибка:', error);
      alert('Ошибка при обработке');
    } finally {
      setLoading(false);
    }
  };

  // ============================================================
  //  ОСНОВНАЯ ОТПРАВКА ФОРМЫ
  // ============================================================
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!form.receiptFile) {
      alert('❌ Чек обязателен!');
      return;
    }
    
    const amount = parseFloat(form.amount);
    if (isNaN(amount) || amount <= 0) {
      alert('Введите корректную сумму!');
      return;
    }
    
    if (form.type === 'prepayment' && !form.selectedItem) {
      alert('❌ Выберите товар из списка!');
      return;
    }
    
    setLoading(true);
    
    let uploadedFilename = null;
    if (form.receiptFile) {
      setUploading(true);
      uploadedFilename = await uploadFile(form.receiptFile);
      setUploading(false);
      if (!uploadedFilename && form.receiptFile) {
        setLoading(false);
        return;
      }
    }
    
    let newUsersData = JSON.parse(JSON.stringify(usersData));
    let newActiveAsset = activeAsset;
    let operationDescription = '';
    let operationType = '';
    
    const currentUser = form.user === 'andrey' ? 'andrey' : 'yuriy';
    const otherUser = currentUser === 'andrey' ? 'yuriy' : 'andrey';
    const userName = newUsersData[currentUser].name;
    
    switch (form.type) {
      case 'vlivaniya':
        const halfInvestment = amount / 2;
        newUsersData[currentUser].invested += amount;
        newUsersData[currentUser].profitability += halfInvestment;
        newUsersData[otherUser].profitability += halfInvestment;
        newActiveAsset += amount;
        operationDescription = `💵 ${userName} влил ${amount.toFixed(2)}₽ (распределено 50/50)`;
        operationType = 'vlivaniya';
        break;
        
      case 'vernul':
        if (newUsersData[currentUser].invested >= amount) {
          newUsersData[currentUser].invested -= amount;
          const halfReturn = amount / 2;
          newUsersData[currentUser].profitability -= halfReturn;
          newUsersData[otherUser].profitability -= halfReturn;
          newActiveAsset -= amount;
          operationDescription = `🔄 ${userName} вернул ${amount.toFixed(2)}₽ из вливаний`;
          operationType = 'vernul';
        } else {
          alert(`Сумма возврата (${amount}₽) превышает сумму вливаний!`);
          setLoading(false);
          return;
        }
        break;
        
      case 'dolg':
        newUsersData[currentUser].debt -= amount;
        newUsersData[otherUser].debt += amount;
        newUsersData[currentUser].profitability -= amount;
        newUsersData[otherUser].profitability += amount;
        operationDescription = `📝 ${userName} дал в долг ${amount.toFixed(2)}₽ ${newUsersData[otherUser].name}`;
        operationType = 'dolg';
        break;
        
      case 'dividendsOne':
        newUsersData[currentUser].profitability += amount;
        newActiveAsset -= amount;
        operationDescription = `🎯 Дивиденды ${userName}: +${amount.toFixed(2)}₽`;
        operationType = 'dividendsOne';
        break;
        
      case 'dividendsAll':
        const halfDiv = amount / 2;
        newUsersData[currentUser].profitability += halfDiv;
        newUsersData[otherUser].profitability += halfDiv;
        newActiveAsset -= amount;
        operationDescription = `👥 Дивиденды всем: ${amount.toFixed(2)}₽`;
        operationType = 'dividendsAll';
        break;
        
      case 'prepayment':
        if (!form.selectedItem) {
          alert('❌ Выберите товар из списка!');
          setLoading(false);
          return;
        }
        
        const itemData = {
          id: form.selectedItem.id,
          name: form.selectedItem.name,
          cost: Number(form.selectedItem.cost) || 0,
          price: Number(form.selectedItem.price) || 0,
          sku: form.selectedItem.sku || '',
          model: form.selectedItem.model || ''
        };
        
        const prepaymentDetailsJson = JSON.stringify(itemData);
        operationDescription = `💳 Предоплата от ${userName} на ${amount.toFixed(2)}₽ (${form.selectedItem.name})`;
        operationType = 'prepayment';
        newActiveAsset += amount;
        form.prepaymentDetails = prepaymentDetailsJson;
        break;
        
      case 'support':
        const halfSupport = amount / 2;
        newUsersData[currentUser].invested += halfSupport;
        newUsersData[otherUser].invested += halfSupport;
        newUsersData[currentUser].profitability += halfSupport;
        newUsersData[otherUser].profitability += halfSupport;
        newActiveAsset += amount;
        operationDescription = `🤝 ${userName} внёс на поддержку ${amount.toFixed(2)}₽ (каждый влил по ${halfSupport.toFixed(2)}₽)`;
        operationType = 'support';
        break;
        
      case 'common':
        newUsersData[currentUser].profitability -= amount;
        newUsersData[otherUser].profitability -= amount;
        operationDescription = `💰 ${userName} положил в общак ${amount.toFixed(2)}₽`;
        operationType = 'common';
        break;
        
      case 'commonOut':
        const halfCommonOut = amount / 2;
        newUsersData[currentUser].profitability += halfCommonOut;
        newUsersData[otherUser].profitability += halfCommonOut;
        operationDescription = `🏦 ${userName} взял из общака ${amount.toFixed(2)}₽ (распределено 50/50)`;
        operationType = 'commonOut';
        break;
        
      default:
        break;
    }
    
    const operation = {
      type: operationType,
      userName: userName,
      amount: amount,
      description: operationDescription,
      comment: form.comment,
      receiptFile: uploadedFilename,
      prepaymentDetails: form.prepaymentDetails || ''
    };
    
    const saved = await saveData(newUsersData, newActiveAsset, operation);
    
    if (saved) {
      setUsersData(newUsersData);
      setActiveAsset(newActiveAsset);
      await loadData();
      await loadItemsAndJobs();
      
      setForm({
        user: 'andrey',
        amount: '',
        type: 'vlivaniya',
        receiptFile: null,
        comment: '',
        prepaymentDetails: '',
        selectedItem: null
      });
      setSearchQuery('');
      setShowSearchResults(false);
      setHasFile(false);
      
      alert(`✅ Операция выполнена!\n${operationDescription}`);
    } else {
      alert('❌ Ошибка при сохранении операции');
    }
    
    setLoading(false);
  };
  
  // ============================================================
  //  ВСПОМОГАТЕЛЬНЫЕ ФУНКЦИИ
  // ============================================================
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setForm({...form, receiptFile: file});
    setHasFile(!!file);
  };
  
  const handleSelectItem = (item) => {
    setForm({
      ...form,
      selectedItem: item,
      prepaymentDetails: item.name,
      amount: item.price
    });
    setSearchQuery(item.name);
    setShowSearchResults(false);
  };
  
  const filteredItems = items.filter(item =>
    item.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    (item.sku && item.sku.toLowerCase().includes(searchQuery.toLowerCase())) ||
    (item.model && item.model.toLowerCase().includes(searchQuery.toLowerCase()))
  );
  
  // ============================================================
  //  ОСНОВНЫЕ РАСЧЁТЫ ДЛЯ ОТОБРАЖЕНИЯ
  // ============================================================
  const totalCost = Array.isArray(items) ? items.reduce((sum, item) => sum + ((item.cost || 0) * (item.quantity || 0)), 0) : 0;
  const totalPrice = Array.isArray(items) ? items.reduce((sum, item) => sum + ((item.price || 0) * (item.quantity || 0)), 0) : 0;
  const coefficient = totalCost > 0 ? (totalPrice / totalCost).toFixed(2) : '0.00';
  
  const cleanJobsSum = jobDetails.finalSum || 0;
  const totalInvested = fundSources.totalInvested || 0;
  const marginOnGoods = totalPrice - totalCost;
  
  const calculatedTotalAssetWithoutMargin = cleanJobsSum + totalInvested;
  const calculatedTotalAssetWithMargin = cleanJobsSum + totalInvested + marginOnGoods;
  const halfCalculatedAsset = calculatedTotalAssetWithMargin / 2;
  
  const adjustedAndreyProfitability = (usersData.andrey?.profitability || 0) + (marginOnGoods / 2);
  const adjustedYuriyProfitability = (usersData.yuriy?.profitability || 0) + (marginOnGoods / 2);
  
  const totalPrepayments = prepayments.reduce((sum, p) => sum + (Number(p.amount) || 0), 0);

  // ============================================================
  //  ГЕНЕРАЦИЯ PDF
  // ============================================================
  const generatePDF = () => {
    if (loading) {
      alert('Данные еще загружаются...');
      return;
    }
    
    const printWindow = window.open('', '_blank');
    if (!printWindow) {
      alert('Разрешите всплывающие окна');
      return;
    }
    
    const currentDate = new Date().toLocaleString('ru-RU');
    
    const formatNumber = (num) => (num || 0).toFixed(2);
    
    const escapeHtml = (str) => {
      if (!str) return '';
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    };
    
    const reportHTML = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="UTF-8">
      <title>Отчет - ТОТОСЕРВИС</title>
      <style>
        * { margin: 0; padding: 0; box-sizing: border-box; }
        body { 
          font-family: 'Segoe UI', Arial, sans-serif; 
          margin: 30px; 
          padding: 20px; 
          background: #f5f7fa; 
        }
        .container {
          max-width: 1100px;
          margin: 0 auto;
          background: white;
          padding: 40px;
          border-radius: 16px;
          box-shadow: 0 4px 20px rgba(0,0,0,0.08);
        }
        .header { 
          text-align: center; 
          margin-bottom: 35px; 
          padding-bottom: 25px; 
          border-bottom: 3px solid #007bff; 
        }
        .header h1 { 
          color: #007bff; 
          margin: 0 0 8px 0; 
          font-size: 28px; 
        }
        .header p { 
          color: #888; 
          margin: 0; 
          font-size: 13px; 
        }
        .header .subtitle {
          color: #666;
          font-size: 14px;
          margin-top: 4px;
        }
        .section { 
          margin-bottom: 30px; 
          page-break-inside: avoid; 
        }
        .section-title { 
          font-size: 17px; 
          font-weight: 700; 
          color: #007bff; 
          margin-bottom: 14px; 
          padding-bottom: 6px; 
          border-bottom: 2px solid #e9ecef; 
          display: flex;
          align-items: center;
          gap: 8px;
        }
        .section-title .badge {
          font-size: 12px;
          font-weight: 400;
          color: #fff;
          background: #007bff;
          padding: 2px 10px;
          border-radius: 12px;
        }
        .info-grid { 
          display: grid; 
          grid-template-columns: 1fr 1fr; 
          gap: 14px; 
          margin-bottom: 14px; 
        }
        .info-card { 
          background: #f8f9fa; 
          padding: 14px 18px; 
          border-radius: 10px; 
          border-left: 4px solid #007bff; 
        }
        .info-card .label { 
          font-size: 12px; 
          color: #888; 
          margin-bottom: 4px; 
        }
        .info-card .value { 
          font-size: 20px; 
          font-weight: 700; 
          color: #007bff; 
        }
        .info-card .value.positive { color: #28a745; }
        .info-card .value.negative { color: #dc3545; }
        .info-card .value.neutral { color: #6c757d; }
        .info-card .sub-value {
          font-size: 13px;
          font-weight: 400;
          color: #666;
          margin-top: 2px;
        }
        .total-card { 
          background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
          padding: 14px 20px; 
          border-radius: 10px; 
          text-align: center; 
          margin-bottom: 14px; 
        }
        .total-card .label { 
          font-size: 13px; 
          color: #555; 
        }
        .total-card .value { 
          font-size: 22px; 
          font-weight: 700; 
          color: #0056b3; 
        }
        .total-card .sub-info {
          font-size: 13px;
          color: #555;
          margin-top: 4px;
        }
        .total-card.green { background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%); }
        .total-card.green .value { color: #2e7d32; }
        .total-card.red { background: linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%); }
        .total-card.red .value { color: #c62828; }
        .total-card.orange { background: linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%); }
        .total-card.orange .value { color: #e65100; }
        .job-details { 
          background: #f8f9fa; 
          padding: 16px 20px; 
          border-radius: 10px; 
          border: 1px solid #e9ecef;
        }
        .job-row { 
          display: flex; 
          justify-content: space-between; 
          padding: 4px 0; 
          font-size: 14px; 
          border-bottom: 1px dashed #e9ecef;
        }
        .job-row:last-child { border-bottom: none; }
        .job-row .label { color: #555; }
        .job-row .value { font-weight: 600; }
        .job-row .value.negative { color: #dc3545; }
        .job-row .value.positive { color: #28a745; }
        .job-total { 
          display: flex; 
          justify-content: space-between; 
          padding: 10px 0 4px 0; 
          font-size: 16px; 
          font-weight: 700; 
          border-top: 2px solid #28a745;
          margin-top: 6px;
          color: #28a745;
        }
        .stats-grid { 
          display: grid; 
          grid-template-columns: 1fr 1fr 1fr 1fr; 
          gap: 12px; 
          margin-bottom: 14px; 
        }
        .stat-card { 
          background: #f8f9fa; 
          padding: 12px 14px; 
          border-radius: 8px; 
          text-align: center; 
          border: 1px solid #e9ecef;
        }
        .stat-card .stat-label { 
          font-size: 11px; 
          color: #888; 
          margin-bottom: 2px; 
        }
        .stat-card .stat-value { 
          font-size: 18px; 
          font-weight: 700; 
        }
        .stat-card .stat-value.positive { color: #28a745; }
        .stat-card .stat-value.negative { color: #dc3545; }
        .stat-card .stat-value.blue { color: #1565c0; }
        .prepayment-item { 
          background: #e7f3ff; 
          padding: 10px 14px; 
          border-radius: 6px; 
          margin-bottom: 6px; 
          font-size: 13px; 
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-left: 3px solid #17a2b8;
        }
        .prepayment-item .prep-name { font-weight: 600; }
        .prepayment-item .prep-amount { font-weight: 700; color: #17a2b8; }
        .prepayment-item .prep-details { font-size: 12px; color: #888; }
        .prepayment-item .prep-date { font-size: 11px; color: #999; }
        .user-cards {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 20px;
          margin-top: 10px;
        }
        .user-card {
          background: #f8f9fa;
          border-radius: 10px;
          padding: 18px 20px;
          border-left: 4px solid #007bff;
        }
        .user-card .user-name { font-size: 16px; font-weight: 700; margin-bottom: 10px; }
        .user-card .user-row {
          display: flex;
          justify-content: space-between;
          padding: 3px 0;
          font-size: 14px;
          border-bottom: 1px dashed #e9ecef;
        }
        .user-card .user-row:last-child { border-bottom: none; }
        .footer { 
          margin-top: 35px; 
          padding-top: 18px; 
          border-top: 2px solid #e9ecef; 
          text-align: center; 
          font-size: 12px; 
          color: #999; 
        }
        @media print {
          body { background: white; padding: 0; margin: 0; }
          .container { box-shadow: none; border-radius: 0; padding: 30px; }
          .section { page-break-inside: avoid; }
        }
        @media (max-width: 768px) {
          .info-grid { grid-template-columns: 1fr; }
          .stats-grid { grid-template-columns: 1fr 1fr; }
          .user-cards { grid-template-columns: 1fr; }
          .container { padding: 20px; }
        }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <h1>📊 ТОТО СЕРВИС</h1>
          <div class="subtitle">Полный финансовый отчет</div>
          <p>📅 Дата формирования: ${escapeHtml(currentDate)}</p>
        </div>
        <!-- 1. ОБЩИЙ АКТИВ -->
        <div class="section">
          <div class="section-title">💰 ОБЩИЙ АКТИВ <span class="badge">с учетом товаров</span></div>
          <div class="total-card" style="background: ${calculatedTotalAssetWithoutMargin >= 0 ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : 'linear-gradient(135deg, #dc3545 0%, #c82333 100%)'}; color: white; border-radius: 12px; padding: 20px;">
            <div class="value" style="color: white; font-size: 32px;">${formatNumber(calculatedTotalAssetWithoutMargin)} ₽</div>
          </div>
          <div class="info-grid" style="margin-top: 12px;">
            <div class="info-card">
              <div class="label">💳 Прибыль от выездов</div>
              <div class="value ${cleanJobsSum >= 0 ? 'positive' : 'negative'}">${formatNumber(cleanJobsSum)} ₽</div>
            </div>
            <div class="info-card">
              <div class="label">💵 Вливания</div>
              <div class="value" style="color: #17a2b8;">${formatNumber(totalInvested)} ₽</div>
            </div>
            <div class="info-card">
              <div class="label">📈 Маржа по товарам</div>
              <div class="value ${marginOnGoods >= 0 ? 'positive' : 'negative'}">${marginOnGoods >= 0 ? '+' : ''}${formatNumber(marginOnGoods)} ₽</div>
            </div>
            <div class="info-card" style="border-left-color: #28a745; background: #f1f8e9;">
              <div class="label">💰 ИТОГО АКТИВ (с маржой)</div>
              <div class="value" style="color: #28a745;">${formatNumber(calculatedTotalAssetWithMargin)} ₽</div>
            </div>
          </div>
        </div>
        <!-- 2. СВОДНАЯ ИНФОРМАЦИЯ -->
        <div class="section">
          <div class="section-title">📊 Сводная информация</div>
          <div class="total-card" style="background: linear-gradient(135deg, #17a2b8 0%, #138496 100%); color: white;">
            <div class="label" style="color: rgba(255,255,255,0.9);">🔄 СУММА ОБОРОТА</div>
            <div class="value" style="color: white; font-size: 26px;">${formatNumber(jobDetails.totalJobsSum)} ₽</div>
            <div class="sub-info" style="color: rgba(255,255,255,0.9);">
              💳 Чистый оборот: <strong style="color: #ffd700;">${formatNumber(jobDetails.finalSum)} ₽</strong>
              &nbsp;|&nbsp; 📊 Всего выездов: ${jobs.length}
            </div>
          </div>
          <div class="job-details">
            <div class="job-row"><span class="label">💰 Общая сумма:</span><span class="value">${formatNumber(jobDetails.totalJobsSum)} ₽</span></div>
            <div class="job-row"><span class="label">💎 Работы:</span><span class="value">${formatNumber(jobDetails.totalWorksSum)} ₽</span></div>
            <div class="job-row"><span class="label">🔩 Запчасти (цена):</span><span class="value">${formatNumber(jobDetails.totalPartsSum)} ₽</span></div>
            <div class="job-row"><span class="label">📦 Себестоимость запчастей:</span><span class="value negative">-${formatNumber(jobDetails.partsCost)} ₽</span></div>
            <div class="job-row"><span class="label">👨‍💻 Сис.админ (5%):</span><span class="value negative">-${formatNumber(jobDetails.sysAdmin)} ₽</span></div>
            <div class="job-row"><span class="label">📊 НДС (6%):</span><span class="value negative">-${formatNumber(jobDetails.nds)} ₽</span></div>
            <div class="job-row"><span class="label">👥 Оплата инженеру (60% от работ):</span><span class="value negative">-${formatNumber(jobDetails.engineerShare)} ₽</span></div>
            <div class="job-row" style="border-bottom: 2px solid #007bff; padding-bottom: 6px; margin-bottom: 2px;">
              <span class="label" style="font-weight: 700; color: #0056b3;">🔄 Сумма после вычетов:</span>
              <span class="value" style="font-weight: 700; color: #0056b3;">${formatNumber(jobDetails.afterFirstDeductions)} ₽</span>
            </div>
            <div class="job-row"><span class="label">🔄 Возврат (15%):</span><span class="value negative">-${formatNumber(jobDetails.returnAmount)} ₽</span></div>
            <div class="job-row" style="border-bottom: 2px solid #ffc107; padding-bottom: 6px; margin-bottom: 2px;">
              <span class="label" style="font-weight: 700; color: #856404;">📦 Сумма после возврата:</span>
              <span class="value" style="font-weight: 700; color: #856404;">${formatNumber(jobDetails.afterReturn)} ₽</span>
            </div>
            <div class="job-row"><span class="label">📦 Себестоимость запчастей:</span><span class="value negative">-${formatNumber(jobDetails.partsCost)} ₽</span></div>
            ${jobDetails.partsProfit > 0 ? `<div class="job-row"><span class="label">📈 Прибыль от запчастей:</span><span class="value positive">+${formatNumber(jobDetails.partsProfit)} ₽</span></div>` : ''}
            <div class="job-total"><span>💳 ИТОГО:</span><span>${formatNumber(jobDetails.finalSum)} ₽</span></div>
          </div>
        </div>
        <!-- 3. ВЛИВАНИЯ -->
        <div class="section">
          <div class="section-title">💵 СУММА ВЛИВАНИЙ</div>
          <div class="total-card" style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white;">
            <div class="value" style="color: white; font-size: 26px;">${formatNumber(fundSources.totalInvested)} ₽</div>
            <div class="sub-info" style="color: rgba(255,255,255,0.9);">
              👤 Андрей: <strong>${formatNumber(usersData.andrey?.invested || 0)} ₽</strong>
              &nbsp;|&nbsp; 👤 Юрий: <strong>${formatNumber(usersData.yuriy?.invested || 0)} ₽</strong>
            </div>
          </div>
        </div>
        <!-- 4. ТОВАРЫ -->
        <div class="section">
          <div class="section-title">📦 Товары на складе</div>
          <div class="info-grid">
            <div class="info-card"><div class="label">💰 Сумма товаров (себестоимость)</div><div class="value negative">${formatNumber(totalCost)} ₽</div></div>
            <div class="info-card"><div class="label">💵 Сумма товаров (цена реализации)</div><div class="value" style="color: #28a745;">${formatNumber(totalPrice)} ₽</div></div>
            <div class="info-card" style="grid-column: 1 / -1; text-align: center; border-left-color: ${coefficient >= 1 ? '#28a745' : '#dc3545'};">
              <div class="label">📈 Коэффициент рентабельности</div>
              <div class="value" style="color: ${coefficient >= 1 ? '#28a745' : '#dc3545'}; font-size: 28px;">⨯${coefficient}</div>
            </div>
          </div>
        </div>
        <!-- 5. СВОДНЫЕ ДАННЫЕ -->
        <div class="section">
          <div class="section-title">📊 Сводные данные</div>
          <div class="stats-grid">
            <div class="stat-card"><div class="stat-label">🤝 На поддержку</div><div class="stat-value negative">+${formatNumber(operationStats.supportTotal)} ₽</div></div>
            <div class="stat-card"><div class="stat-label">💰 В общак</div><div class="stat-value positive">+${formatNumber(operationStats.commonTotal)} ₽</div></div>
            <div class="stat-card"><div class="stat-label">🏦 Из общака</div><div class="stat-value negative">-${formatNumber(operationStats.commonOutTotal)} ₽</div></div>
            <div class="stat-card"><div class="stat-label">💳 Предоплаты</div><div class="stat-value blue">${formatNumber(operationStats.prepaymentTotal)} ₽</div></div>
          </div>
          <div class="total-card ${operationStats.balance >= 0 ? 'green' : 'red'}">
            <div class="label">💰 Баланс общака</div>
            <div class="value">${formatNumber(operationStats.balance)} ₽</div>
          </div>
        </div>
        <!-- 6. ПРЕДОПЛАТЫ -->
        <div class="section">
          <div class="section-title">💳 Предоплаты <span class="badge">${prepayments.length} записей</span></div>
          <div class="total-card" style="background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);">
            <div class="label">💰 Общая сумма предоплат</div>
            <div class="value" style="color: #1565c0;">${formatNumber(totalPrepayments)} ₽</div>
          </div>
          ${prepayments.length === 0 ? `<div style="text-align: center; color: #999; padding: 20px;">Нет предоплат</div>` : prepayments.map(p => {
            const amount = Number(p.amount) || 0;
            let itemDetails = '';
            if (p.prepayment_details && p.prepayment_details !== 'null') {
              try {
                const itemData = JSON.parse(p.prepayment_details);
                itemDetails = `📦 ${escapeHtml(itemData.name || '')}`;
              } catch (e) {}
            }
            return `<div class="prepayment-item"><div><span class="prep-name">${escapeHtml(p.user_name)}</span> <span class="prep-amount">${formatNumber(amount)} ₽</span> ${itemDetails ? `<span class="prep-details">${itemDetails}</span>` : ''}</div><div class="prep-date">${new Date(p.created_at).toLocaleDateString('ru-RU')}</div></div>`;
          }).join('')}
        </div>
        <!-- 7. РАСПРЕДЕЛЕНИЕ АКТИВА -->
        <div class="section">
          <div class="section-title">👥 Распределение актива</div>
          <div class="info-grid">
            <div class="info-card" style="border-left-color: ${halfCalculatedAsset >= 0 ? '#28a745' : '#dc3545'};">
              <div class="label">👤 Андрей - Доля актива (60%)</div>
              <div class="value ${halfCalculatedAsset >= 0 ? 'positive' : 'negative'}">${formatNumber(halfCalculatedAsset)} ₽</div>
            </div>
            <div class="info-card" style="border-left-color: ${halfCalculatedAsset >= 0 ? '#28a745' : '#dc3545'};">
              <div class="label">👤 Юрий - Доля актива (50%)</div>
              <div class="value ${halfCalculatedAsset >= 0 ? 'positive' : 'negative'}">${formatNumber(halfCalculatedAsset)} ₽</div>
            </div>
          </div>
        </div>
        <!-- 8. ДИВИДЕНДЫ -->
        <div class="section">
          <div class="section-title">🎯 Выплаченные дивиденды</div>
          <div class="info-grid">
            <div class="info-card" style="border-left-color: #28a745;"><div class="label">👤 Андрей</div><div class="value positive">${formatNumber(andreyDividends || 0)} ₽</div></div>
            <div class="info-card" style="border-left-color: #28a745;"><div class="label">👤 Юрий</div><div class="value positive">${formatNumber(yuriyDividends || 0)} ₽</div></div>
          </div>
        </div>
        <!-- 9. КАРТОЧКИ ПОЛЬЗОВАТЕЛЕЙ -->
        <div class="section">
          <div class="section-title">👤 Пользователи</div>
          <div class="user-cards">
            <div class="user-card" style="border-left-color: ${adjustedAndreyProfitability >= 0 ? '#28a745' : '#dc3545'};">
              <div class="user-name">👤 ${usersData.andrey?.name || 'Андрей'}</div>
              <div class="user-row"><span>💵 Влил</span><span style="color: #17a2b8; font-weight: 700;">${formatNumber(usersData.andrey?.invested || 0)} ₽</span></div>
              <div class="user-row"><span>${(usersData.andrey?.debt || 0) > 0 ? '💳 Должен' : (usersData.andrey?.debt || 0) < 0 ? '💳 Одолжил' : '💳 Долг'}</span><span style="font-weight: 900; color: ${(usersData.andrey?.debt || 0) !== 0 ? (usersData.andrey?.debt || 0) > 0 ? '#dc3545' : '#28a745' : '#6c757d'};">${(usersData.andrey?.debt || 0) !== 0 ? formatNumber(Math.abs(usersData.andrey?.debt || 0)) + ' ₽' : '—'}</span></div>
            </div>
            <div class="user-card" style="border-left-color: ${adjustedYuriyProfitability >= 0 ? '#28a745' : '#dc3545'};">
              <div class="user-name">👤 ${usersData.yuriy?.name || 'Юрий'}</div>
              <div class="user-row"><span>💵 Влил</span><span style="color: #17a2b8; font-weight: 700;">${formatNumber(usersData.yuriy?.invested || 0)} ₽</span></div>
              <div class="user-row"><span>${(usersData.yuriy?.debt || 0) > 0 ? '💳 Должен' : (usersData.yuriy?.debt || 0) < 0 ? '💳 Одолжил' : '💳 Долг'}</span><span style="font-weight: 900; color: ${(usersData.yuriy?.debt || 0) !== 0 ? (usersData.yuriy?.debt || 0) > 0 ? '#dc3545' : '#28a745' : '#6c757d'};">${(usersData.yuriy?.debt || 0) !== 0 ? formatNumber(Math.abs(usersData.yuriy?.debt || 0)) + ' ₽' : '—'}</span></div>
            </div>
          </div>
        </div>
        <div class="footer"><p>© ${new Date().getFullYear()} ТОТОСЕРВИС — Все права защищены</p><p style="font-size: 11px; color: #bbb;">Отчет сгенерирован автоматически</p></div>
      </div>
    </body>
    </html>
    `;
    
    printWindow.document.write(reportHTML);
    printWindow.document.close();
  };
  
  // ============================================================
  //  РЕНДЕРИНГ
  // ============================================================
  return (
    <div>
      {/* ЗАГОЛОВОК */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexWrap: 'wrap', gap: '10px' }}>
        <h2>📊 Рентабельность</h2>
        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
          <button style={{ ...styles.dangerButton, background: '#ffc107', color: '#333' }} onClick={undoLastOperation} disabled={loading}>↩️ Отменить</button>
          <button style={{ ...styles.button, background: '#17a2b8' }} onClick={generatePDF} disabled={loading}>📄 Отчет</button>
        </div>
      </div>
      
      {/* ОБЩИЙ АКТИВ */}
      <div style={{
        background: calculatedTotalAssetWithoutMargin >= 0 ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : 'linear-gradient(135deg, #dc3545 0%, #c82333 100%)',
        color: 'white',
        padding: '20px',
        borderRadius: '12px',
        marginBottom: '30px',
        textAlign: 'center'
      }}>
        <div style={{ fontSize: '14px', opacity: 0.9 }}>ОБЩИЙ АКТИВ (с себест. товаров)</div>
        <div style={{ fontSize: '32px', fontWeight: 'bold' }}>{calculatedTotalAssetWithoutMargin.toFixed(2)} ₽</div>
        <div style={{ fontSize: '12px', opacity: 0.8, marginTop: '10px', textAlign: 'left', maxWidth: '400px', margin: '10px auto 0' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}><span>💳 Прибыль от выездов:</span><span>{cleanJobsSum.toFixed(2)} ₽</span></div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}><span>💵 Вливания:</span><span>{totalInvested.toFixed(2)} ₽</span></div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}><span>📈 Маржа по товарам:</span><span style={{ color: marginOnGoods >= 0 ? '#90EE90' : '#ff6b6b' }}>{marginOnGoods >= 0 ? '+' : ''}{marginOnGoods.toFixed(2)} ₽</span></div>
          <div style={{ borderTop: '1px solid rgba(255,255,255,0.3)', marginTop: '5px', paddingTop: '5px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 'bold' }}><span>💰 ИТОГО АКТИВ (с маржой):</span><span>{calculatedTotalAssetWithMargin.toFixed(2)} ₽</span></div>
          </div>
        </div>
        {calculatedTotalAssetWithoutMargin < 0 && <div style={{ fontSize: '12px', marginTop: '5px', opacity: 0.8 }}>⚠️ Отрицательный актив</div>}
      </div>
      
      {/* СВОДНАЯ ИНФОРМАЦИЯ */}
      <div style={{ background: '#f8f9fa', borderRadius: '12px', padding: '20px', marginBottom: '20px', border: '1px solid #dee2e6' }}>
        <h3 style={{ margin: '0 0 15px 0', textAlign: 'center', color: '#007bff' }}>📊 Сводная информация</h3>
        
        <div style={{ background: 'linear-gradient(135deg, #17a2b8 0%, #138496 100%)', color: 'white', padding: '15px', borderRadius: '10px', marginBottom: '20px', textAlign: 'center' }}>
          <div style={{ fontSize: '14px', opacity: 0.9 }}>🔄 СУММА ОБОРОТА</div>
          <div style={{ fontSize: '24px', fontWeight: 'bold', marginTop: '4px' }}>{jobDetails.totalJobsSum.toFixed(2)} ₽</div>
          <div style={{ fontSize: '14px', opacity: 0.9, marginTop: '6px' }}>💳 Чистый оборот: <strong style={{ color: '#ffd700' }}>{jobDetails.finalSum.toFixed(2)} ₽</strong></div>
          <div style={{ fontSize: '12px', opacity: 0.8, marginTop: '4px' }}>📊 Товары и выезды: {jobs.length}</div>
        </div>
        
        <div style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: 'white', padding: '15px', borderRadius: '10px', marginBottom: '20px', textAlign: 'center' }}>
          <div style={{ fontSize: '14px', opacity: 0.9 }}>💵 СУММА ВЛИВАНИЙ</div>
          <div style={{ fontSize: '28px', fontWeight: 'bold' }}>{(fundSources.totalInvested).toFixed(2)} ₽</div>
        </div>
        
        <div style={{ display: 'flex', justifyContent: 'space-between', gap: '15px', marginBottom: '20px', flexWrap: 'wrap' }}>
          <div style={{ flex: 1, background: '#fff', padding: '12px', borderRadius: '8px', textAlign: 'center' }}>
            <div style={{ fontSize: '12px', color: '#666' }}>👤 Андрей - Влил</div>
            <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#17a2b8' }}>{(usersData.andrey?.invested || 0).toFixed(2)} ₽</div>
          </div>
          <div style={{ flex: 1, background: '#fff', padding: '12px', borderRadius: '8px', textAlign: 'center' }}>
            <div style={{ fontSize: '12px', color: '#666' }}>👤 Юрий - Влил</div>
            <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#17a2b8' }}>{(usersData.yuriy?.invested || 0).toFixed(2)} ₽</div>
          </div>
        </div>
        
        <div style={{ background: '#e8f5e9', borderRadius: '8px', padding: '15px', marginBottom: '20px', border: '1px solid #a5d6a7' }}>
          <h4 style={{ margin: '0 0 10px 0', color: '#2e7d32', fontSize: '14px' }}>💳 Источники средств для товаров</h4>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}><span>💰 Деньги из вливаний:</span><strong style={{ color: '#2e7d32' }}>{fundSources.fromInvestments.toFixed(2)} ₽</strong></div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}><span>💵 Деньги с оборота:</span><strong style={{ color: '#1565c0' }}>{fundSources.fromTurnover.toFixed(2)} ₽</strong></div>
            <div style={{ display: 'flex', justifyContent: 'space-between', borderTop: '1px solid #a5d6a7', paddingTop: '6px', marginTop: '4px' }}><span>📦 Итого товаров на складе:</span><strong>{fundSources.totalCost.toFixed(2)} ₽</strong></div>
            {fundSources.remainingInvestments > 0 && <div style={{ fontSize: '12px', color: '#2e7d32', fontStyle: 'italic' }}>✅ Остаток вливаний: {fundSources.remainingInvestments.toFixed(2)} ₽</div>}
          </div>
        </div>
        
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '20px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', borderBottom: '1px solid #dee2e6' }}><span>💰 Сумма товаров (себестоимость):</span><strong style={{ color: '#dc3545' }}> {totalCost.toFixed(2)} ₽</strong></div>
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', borderBottom: '1px solid #dee2e6' }}><span>💵 Сумма товаров (цена реализации):</span><strong>{totalPrice.toFixed(2)} ₽</strong></div>
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0' }}><span>📈 Коэффициент рентабельности:</span><strong style={{ color: coefficient >= 1 ? '#28a745' : '#dc3545' }}>⨯{coefficient}</strong></div>
        </div>
        
        {/* ВЫЕЗДЫ ИНЖЕНЕРОВ (РАЗВОРАЧИВАЕТСЯ) */}
        <div style={{ background: '#fff', borderRadius: '8px', border: '1px solid #dee2e6', marginBottom: '20px', overflow: 'hidden' }}>
          <div onClick={() => setJobsExpanded(!jobsExpanded)} style={{ padding: '15px', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: jobsExpanded ? '#e7f3ff' : '#f8f9fa', transition: 'background 0.2s', userSelect: 'none' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <span style={{ fontSize: '20px' }}>🔧</span>
              <div>
                <h4 style={{ margin: 0, color: '#007bff' }}>Продажи | Выезды</h4>
                <div style={{ fontSize: '14px', color: '#666' }}>{jobs.length} конверсий | Сумма: <strong>{jobDetails.totalJobsSum.toFixed(2)} ₽</strong></div>
              </div>
            </div>
            <div style={{ fontSize: '24px', transition: 'transform 0.3s', transform: jobsExpanded ? 'rotate(180deg)' : 'rotate(0deg)' }}>▼</div>
          </div>
          {!jobsExpanded && (
            <div style={{ padding: '12px 15px', borderTop: '1px solid #dee2e6', background: '#f8f9fa' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px' }}><span>💰 Общая сумма:</span><strong>{jobDetails.totalJobsSum.toFixed(2)} ₽</strong></div>
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', marginTop: '4px', borderTop: '2px solid #28a745', paddingTop: '4px' }}><span style={{ fontWeight: 'bold', color: '#28a745' }}>💳 ИТОГО:</span><span style={{ fontWeight: 'bold', color: '#28a745' }}>{jobDetails.finalSum.toFixed(2)} ₽</span></div>
            </div>
          )}
          {jobsExpanded && (
            <div style={{ padding: '15px', borderTop: '1px solid #dee2e6' }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', color: '#666' }}><span>💎 Работы:</span><span>+{jobDetails.totalWorksSum.toFixed(2)} ₽</span></div>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', color: '#666' }}><span>🔩 Запчасти (цена):</span><span>+{jobDetails.totalPartsSum.toFixed(2)} ₽</span></div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}><span>💰 Общая сумма:</span><strong>={jobDetails.totalJobsSum.toFixed(2)} ₽</strong></div>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px' }}><span>👨‍💻 Сис.админ (5%):</span><span style={{ color: '#dc3545' }}>-{jobDetails.sysAdmin.toFixed(2)} ₽</span></div>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px' }}><span>📊 НДС (6%):</span><span style={{ color: '#dc3545' }}>-{jobDetails.nds.toFixed(2)} ₽</span></div>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', borderBottom: '1px dashed #dee2e6', paddingBottom: '6px' }}><span>👥 Оплата инженеру (60% от работ):</span><span style={{ color: '#dc3545' }}>-{jobDetails.engineerShare.toFixed(2)} ₽</span></div>
                <div style={{ display: 'flex', justifyContent: 'space-between', background: '#e7f3ff', borderRadius: '4px', padding: '6px 8px' }}><span style={{ fontWeight: 'bold', color: '#0056b3' }}>🔄 Сумма после вычетов:</span><span style={{ fontWeight: 'bold', color: '#0056b3' }}>={jobDetails.afterFirstDeductions.toFixed(2)} ₽</span></div>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px' }}><span>🔄 Возврат (15%):</span><span style={{ color: '#dc3545' }}>-{jobDetails.returnAmount.toFixed(2)} ₽</span></div>
                <div style={{ display: 'flex', justifyContent: 'space-between', background: '#fff3cd', borderRadius: '4px', padding: '6px 8px', border: '1px solid #ffc107' }}><span style={{ fontWeight: 'bold', color: '#856404' }}>📦 Сумма после возврата:</span><span style={{ fontWeight: 'bold', color: '#856404' }}>={jobDetails.afterReturn.toFixed(2)} ₽</span></div>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', borderBottom: '1px dashed #dee2e6', paddingBottom: '6px' }}><span>📦 Себестоимость запчастей:</span><span style={{ color: '#dc3545' }}>-{jobDetails.partsCost.toFixed(2)} ₽</span></div>
                {jobDetails.partsProfit > 0 && <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', color: '#28a745' }}><span>📈 Прибыль от запчастей:</span><span>{jobDetails.partsProfit.toFixed(2)} ₽</span></div>}
                <div style={{ display: 'flex', justifyContent: 'space-between', background: '#28a745', color: 'white', borderRadius: '6px', padding: '8px 12px', marginTop: '4px' }}><span style={{ fontWeight: 'bold', fontSize: '15px' }}>💳 ИТОГО:</span><span style={{ fontWeight: 'bold', fontSize: '19px' }}>{jobDetails.finalSum.toFixed(2)} ₽</span></div>
              </div>
            </div>
          )}
        </div>
        
        {/* СВОДНЫЕ ДАННЫЕ (АВТООБНОВЛЯЮТСЯ) */}
        <div style={{ background: 'white', borderRadius: '8px', padding: '15px', border: '1px solid #dee2e6', marginBottom: '20px' }}>
          <h4 style={{ margin: '0 0 12px 0', color: '#007bff', textAlign: 'center' }}>📊 Сводные данные</h4>
          <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr 1fr' : 'repeat(3, 1fr)', gap: '10px' }}>
            <div style={{ background: '#fff5f5', padding: '10px', borderRadius: '6px', textAlign: 'center', border: '1px solid #ffcdd2' }}><div style={{ fontSize: '11px', color: '#666' }}>🤝 На поддержку</div><div style={{ fontSize: '16px', fontWeight: 'bold', color: '#1d65f4' }}>+{operationStats.supportTotal.toFixed(2)} ₽</div></div>
            <div style={{ background: '#f1f8e9', padding: '10px', borderRadius: '6px', textAlign: 'center', border: '1px solid #c8e6c9' }}><div style={{ fontSize: '11px', color: '#666' }}>💰 В общак</div><div style={{ fontSize: '16px', fontWeight: 'bold', color: '#2e7d32' }}>+{operationStats.commonTotal.toFixed(2)} ₽</div></div>
            <div style={{ background: '#fff5f5', padding: '10px', borderRadius: '6px', textAlign: 'center', border: '1px solid #ffcdd2' }}><div style={{ fontSize: '11px', color: '#666' }}>🏦 Из общака</div><div style={{ fontSize: '16px', fontWeight: 'bold', color: '#dc3545' }}>-{operationStats.commonOutTotal.toFixed(2)} ₽</div></div>
          </div>
          <div style={{ marginTop: '12px', padding: '10px', background: operationStats.balance >= 0 ? '#e8f5e9' : '#ffebee', borderRadius: '6px', textAlign: 'center', border: `1px solid ${operationStats.balance >= 0 ? '#a5d6a7' : '#ffcdd2'}` }}>
            <span style={{ fontSize: '13px' }}>💰 Баланс общака: </span><strong style={{ fontSize: '16px', color: operationStats.balance >= 0 ? '#2e7d32' : '#c62828' }}>{operationStats.balance.toFixed(2)} ₽</strong>
          </div>
        </div>
        
        {/* СУММА ПРЕДОПЛАТ (РАЗВОРАЧИВАЕТСЯ) */}
        <div style={{ background: '#fff', borderRadius: '8px', border: '1px solid #dee2e6', marginBottom: '20px', overflow: 'hidden' }}>
          <div onClick={() => setPrepaymentsExpanded(!prepaymentsExpanded)} style={{ padding: '15px', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: prepaymentsExpanded ? '#e7f3ff' : '#f8f9fa', transition: 'background 0.2s', userSelect: 'none' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <span style={{ fontSize: '20px' }}>💳</span>
              <div><h4 style={{ margin: 0, color: '#007bff' }}>Предоплаты</h4><div style={{ fontSize: '14px', color: '#666' }}>{prepayments.length} запись(ей) на сумму <strong>{totalPrepayments.toFixed(2)} ₽</strong></div></div>
            </div>
            <div style={{ fontSize: '24px', transition: 'transform 0.3s', transform: prepaymentsExpanded ? 'rotate(180deg)' : 'rotate(0deg)' }}>▼</div>
          </div>
          {prepaymentsExpanded && (
            <div style={{ padding: '15px', borderTop: '1px solid #dee2e6' }}>
              {prepayments.length === 0 ? <div style={{ textAlign: 'center', color: '#999', padding: '20px' }}>Нет предоплат</div> : prepayments.map((p, index) => {
                const amount = Number(p.amount) || 0;
                let itemName = '';
                if (p.prepayment_details && p.prepayment_details !== 'null') { try { const itemData = JSON.parse(p.prepayment_details); itemName = itemData.name || ''; } catch (e) {} }
                return (
                  <div key={p.id} style={{ background: index % 2 === 0 ? '#f8f9fa' : 'white', padding: '10px 12px', borderRadius: '6px', marginBottom: '8px', borderLeft: '3px solid #17a2b8' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '8px' }}>
                      <div><strong>{p.user_name}</strong><span style={{ marginLeft: '10px', fontSize: '14px', color: '#17a2b8', fontWeight: 'bold' }}>{amount.toFixed(2)} ₽</span>{itemName && <div style={{ fontSize: '12px', color: '#666', marginTop: '2px' }}>📦 {itemName}</div>}</div>
                      <div style={{ fontSize: '12px', color: '#999' }}>{new Date(p.created_at).toLocaleDateString()}</div>
                    </div>
                    {p.comment && <div style={{ fontSize: '12px', color: '#888', fontStyle: 'italic', marginTop: '2px' }}>💬 {p.comment}</div>}
                    {p.receipt_file && <div style={{ marginTop: '4px' }}><a href={`${API_URL}/uploads/${p.receipt_file}`} target="_blank" rel="noopener noreferrer" style={{ fontSize: '12px', color: '#007bff' }}>📎 Чек</a></div>}
                    <div style={{ marginTop: '8px' }}>
                      <button onClick={() => handlePrepaymentRelease(p.id)} disabled={loading} style={{ background: '#28a745', color: 'white', border: 'none', padding: '6px 16px', borderRadius: '4px', cursor: 'pointer', fontSize: '13px', fontWeight: 'bold', opacity: loading ? 0.6 : 1 }}>✅ Отпустить</button>
                      <span style={{ marginLeft: '8px', fontSize: '11px', color: '#999' }}>С вычетами: 5% сис.админ, 6% НДС, 15% возврат</span>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
        
        {/* ДОЛЯ АКТИВА */}
        <div style={{ display: 'flex', justifyContent: 'space-between', gap: '15px', marginBottom: '20px', flexWrap: 'wrap' }}>
          <div style={{ flex: 1, background: '#fff', padding: '12px', borderRadius: '8px', textAlign: 'center', border: `1px solid ${halfCalculatedAsset >= 0 ? '#28a745' : '#dc3545'}` }}>
            <div style={{ fontSize: '12px', color: '#666' }}>👤 Андрей - Доля актива (50%)</div>
            <div style={{ fontSize: '20px', fontWeight: 'bold', color: halfCalculatedAsset >= 0 ? '#28a745' : '#dc3545' }}>{halfCalculatedAsset.toFixed(2)} ₽</div>
          </div>
          <div style={{ flex: 1, background: '#fff', padding: '12px', borderRadius: '8px', textAlign: 'center', border: `1px solid ${halfCalculatedAsset >= 0 ? '#28a745' : '#dc3545'}` }}>
            <div style={{ fontSize: '12px', color: '#666' }}>👤 Юрий - Доля актива (50%)</div>
            <div style={{ fontSize: '20px', fontWeight: 'bold', color: halfCalculatedAsset >= 0 ? '#28a745' : '#dc3545' }}>{halfCalculatedAsset.toFixed(2)} ₽</div>
          </div>
        </div>
        
        <div style={{ display: 'flex', justifyContent: 'space-between', gap: '15px', flexWrap: 'wrap' }}>
          <div style={{ flex: 1, background: '#fff', padding: '12px', borderRadius: '8px', textAlign: 'center' }}><div style={{ fontSize: '12px', color: '#666' }}>👤 Андрей - Дивиденды</div><div style={{ fontSize: '20px', fontWeight: 'bold', color: '#28a745' }}>{(andreyDividends || 0).toFixed(2)} ₽</div></div>
          <div style={{ flex: 1, background: '#fff', padding: '12px', borderRadius: '8px', textAlign: 'center' }}><div style={{ fontSize: '12px', color: '#666' }}>👤 Юрий - Дивиденды</div><div style={{ fontSize: '20px', fontWeight: 'bold', color: '#28a745' }}>{(yuriyDividends || 0).toFixed(2)} ₽</div></div>
        </div>
      </div>
      
      {/* ФОРМА ВВОДА ОПЕРАЦИЙ */}
      <div style={{ ...styles.form, marginTop: '30px' }}>
        <h3 style={{ margin: '0 0 10px 0' }}>✏️ Ввод операции</h3>
        <form onSubmit={handleSubmit}>
          <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fill, minmax(200px, 1fr))', gap: '15px' }}>
            <select style={styles.selectInput} value={form.user} onChange={(e) => setForm({...form, user: e.target.value})}>
              <option value="andrey">Андрей</option>
              <option value="yuriy">Юрий</option>
            </select>
            <input style={styles.input} type="number" step="0.01" placeholder="Сумма" value={form.amount} onChange={(e) => setForm({...form, amount: e.target.value})} required />
            <select style={styles.selectInput} value={form.type} onChange={(e) => setForm({...form, type: e.target.value})}>
              <option value="vlivaniya">💵 Вливания</option>
              <option value="vernul">🔄 Вернул</option>
              <option value="dolg">📝 Долг</option>
              <option value="dividendsOne">🎯 Дивиденды одному</option>
              <option value="dividendsAll">👥 Дивиденды всем</option>
              <option value="prepayment">💳 Предоплата</option>
              <option value="support">🤝 На поддержку</option>
              <option value="common">💰 В общак</option>
              <option value="commonOut">🏦 Из общака</option>
            </select>
            {form.type === 'prepayment' && (
              <div style={{ position: 'relative' }}>
                <input style={styles.input} type="text" placeholder="🔍 Поиск товара на складе..." value={searchQuery} onChange={(e) => { setSearchQuery(e.target.value); setShowSearchResults(true); if (!e.target.value) { setForm({...form, selectedItem: null, prepaymentDetails: '', amount: ''}); } }} onFocus={() => setShowSearchResults(true)} />
                {showSearchResults && searchQuery && (
                  <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: 'white', border: '1px solid #ccc', borderRadius: '6px', maxHeight: '200px', overflowY: 'auto', zIndex: 1000, boxShadow: '0 4px 8px rgba(0,0,0,0.1)' }}>
                    {filteredItems.length === 0 ? <div style={{ padding: '10px', color: '#999' }}>Товары не найдены</div> : filteredItems.map(item => (
                      <div key={item.id} onClick={() => handleSelectItem(item)} style={{ padding: '10px', cursor: 'pointer', borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} onMouseEnter={(e) => e.target.style.background = '#f0f0f0'} onMouseLeave={(e) => e.target.style.background = 'white'}>
                        <div><div style={{ fontWeight: 'bold' }}>{item.name}</div><div style={{ fontSize: '12px', color: '#666' }}>{item.sku && `Артикул: ${item.sku} | `}Остаток: {item.quantity}</div></div>
                        <div style={{ textAlign: 'right' }}><div style={{ color: '#28a745' }}>{item.price} ₽</div><div style={{ fontSize: '11px', color: '#dc3545' }}>Себест: {item.cost} ₽</div></div>
                      </div>
                    ))}
                  </div>
                )}
                {form.selectedItem && (
                  <div style={{ marginTop: '8px', padding: '8px 12px', background: '#e8f5e9', borderRadius: '6px', border: '1px solid #a5d6a7', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div><strong>✅ {form.selectedItem.name}</strong><div style={{ fontSize: '12px', color: '#666' }}>Себестоимость: {form.selectedItem.cost} ₽ | Цена: {form.selectedItem.price} ₽</div></div>
                    <button type="button" onClick={() => { setForm({...form, selectedItem: null, prepaymentDetails: '', amount: ''}); setSearchQuery(''); }} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '18px', color: '#999' }}>✕</button>
                  </div>
                )}
              </div>
            )}
            <input style={styles.input} type="text" placeholder="📝 Комментарий" value={form.comment} onChange={(e) => setForm({...form, comment: e.target.value})} />
            <button type="button" onClick={() => document.getElementById('receiptInput').click()} style={{ background: hasFile ? '#28a745' : '#dc3545', color: 'white', border: 'none', padding: '12px', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold', fontSize: '16px', minWidth: '80px', minHeight: '48px' }}>{hasFile ? '✅ ЧЕК' : '📝 ЧЕК'}</button>
            <input id="receiptInput" type="file" accept="image/*,application/pdf" onChange={handleFileChange} style={{ display: 'none' }} />
            <button type="submit" style={styles.squareButton} disabled={loading || uploading}>{loading || uploading ? '⏳' : '📤 Отпр'}</button>
          </div>
        </form>
      </div>
      
      {/* ИСТОРИЯ ОПЕРАЦИЙ С ФИЛЬТРОМ */}
      <div style={{ 
        ...styles.historyWindow,
        backgroundColor: '#311d270b',
        border: '2px solid #210c02a9',
        borderRadius: '12px',
        padding: '20px'
      }}>
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          marginBottom: '15px',
          flexWrap: 'wrap',
          gap: '10px'
        }}>
          <h3 style={{ margin: 0 }}>📜 История операций</h3>
          <span style={{ fontSize: '14px', color: '#666' }}>
            Всего: {history.length} операций
          </span>
        </div>
        
        {/* --- ФИЛЬТР --- */}
        <div style={{ 
          display: 'flex', 
          gap: '8px', 
          marginBottom: '15px',
          flexWrap: 'wrap',
          padding: '10px',
          background: 'white',
          borderRadius: '8px',
          border: '1px solid #dee2e6'
        }}>
          {filterOptions.map(option => (
            <button
              key={option.value}
              onClick={() => setFilterType(option.value)}
              style={{
                padding: '6px 14px',
                borderRadius: '20px',
                border: 'none',
                cursor: 'pointer',
                fontSize: '13px',
                fontWeight: filterType === option.value ? 'bold' : 'normal',
                background: filterType === option.value ? '#007bff' : '#f1f1f1',
                color: filterType === option.value ? 'white' : '#333',
                transition: 'all 0.2s',
                minHeight: '36px'
              }}
              onMouseEnter={(e) => {
                if (filterType !== option.value) {
                  e.target.style.background = '#e9ecef';
                }
              }}
              onMouseLeave={(e) => {
                if (filterType !== option.value) {
                  e.target.style.background = '#f1f1f1';
                }
              }}
            >
              {option.label}
            </button>
          ))}
        </div>
        
        {/* --- ОТОБРАЖЕНИЕ ОТФИЛЬТРОВАННОЙ ИСТОРИИ --- */}
        {getFilteredHistory().length === 0 ? (
          <div style={{ textAlign: 'center', color: '#6c757d', padding: '40px' }}>
            {filterType === 'all' ? 'Пока нет операций' : 'Нет операций этого типа'}
          </div>
        ) : (
          getFilteredHistory().slice(0, 50).map(item => (
            <div 
              key={item.id} 
              style={{
                ...styles.historyItem,
                background: item.cancelled ? '#fefdfc' : 'transparent',
                opacity: item.cancelled ? 0.7 : 1,
                borderLeft: item.cancelled ? '3px solid #dc3545' : 'none'
              }}
            >
              <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: '5px' }}>
                  <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
                    {new Date(item.created_at).toLocaleString()}
                  </span>
                  <span style={{ textDecoration: item.cancelled ? 'line-through' : 'none' }}>
                    {item.description}
                  </span>
                  {item.receipt_file && !item.cancelled && (
                    <a 
                      href={`${API_URL}/uploads/${item.receipt_file}`} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      style={{ fontSize: '12px', color: '#007bff' }}
                    >
                      📎 Чек
                    </a>
                  )}
                  {item.cancelled && (
                    <span style={{ color: '#dc3545', fontWeight: 'bold' }}>❌ ОТМЕНЕНА</span>
                  )}
                </div>
                {item.comment && !item.cancelled && (
                  <div style={{ 
                    fontSize: '12px', 
                    color: '#666', 
                    fontStyle: 'italic',
                    paddingLeft: '10px',
                    borderLeft: '2px solid #007bff'
                  }}>
                    💬 {item.comment}
                  </div>
                )}
                {item.prepayment_details && !item.cancelled && (
                  <div style={{ 
                    fontSize: '12px', 
                    color: '#17a2b8',
                    paddingLeft: '10px',
                    borderLeft: '2px solid #17a2b8'
                  }}>
                    📝 {item.prepayment_details}
                  </div>
                )}
              </div>
            </div>
          ))
        )}
      </div>
      
      {/* КАРТОЧКИ ПОЛЬЗОВАТЕЛЕЙ */}
      <div style={{ display: 'flex', gap: '20px', marginBottom: '30px', flexWrap: 'wrap', flexDirection: isMobile ? 'column' : 'row' }}>
        <div style={{ flex: 1, minWidth: isMobile ? 'auto' : '250px', background: '#dbd4d394', borderRadius: '12px', padding: '20px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', borderLeft: `4px solid ${adjustedAndreyProfitability >= 0 ? '#28a745' : '#dc3545'}` }}>
          <h3 style={{ margin: '0 0 15px 0', textAlign: 'center' }}>👤 {usersData.andrey?.name || 'Андрей'}</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <div style={{ background: '#17a2b8', color: 'white', padding: '12px', borderRadius: '8px', textAlign: 'center' }}><div style={{ fontSize: '12px', opacity: 0.9 }}>Влил</div><div style={{ fontSize: '20px', fontWeight: 'bold' }}>{(usersData.andrey?.invested || 0).toFixed(2)} ₽</div></div>
            <div style={{ background: (usersData.andrey?.debt || 0) > 0 ? '#dc3545' : ((usersData.andrey?.debt || 0) < 0 ? '#28a745' : '#6c757d'), color: 'white', padding: '8px 12px', borderRadius: '8px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: isMobile ? 'auto' : '15%', minWidth: '120px' }}>
              <span style={{ fontSize: '13px' }}>{(usersData.andrey?.debt || 0) > 0 ? 'Должен' : ((usersData.andrey?.debt || 0) < 0 ? 'Одолжил' : 'Долг')}</span>
              <span style={{ fontSize: '16px', fontWeight: 'bold' }}>{(usersData.andrey?.debt || 0) !== 0 ? Math.abs(usersData.andrey?.debt || 0).toFixed(2) + '₽' : '—'}</span>
            </div>
          </div>
        </div>
        <div style={{ flex: 1, minWidth: isMobile ? 'auto' : '250px', background: '#dbd4d394', borderRadius: '12px', padding: '20px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', borderLeft: `4px solid ${adjustedYuriyProfitability >= 0 ? '#28a745' : '#dc3545'}` }}>
          <h3 style={{ margin: '0 0 15px 0', textAlign: 'center' }}>👤 {usersData.yuriy?.name || 'Юрий'}</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <div style={{ background: '#17a2b8', color: 'white', padding: '12px', borderRadius: '8px', textAlign: 'center' }}><div style={{ fontSize: '12px', opacity: 0.9 }}>Влил</div><div style={{ fontSize: '20px', fontWeight: 'bold' }}>{(usersData.yuriy?.invested || 0).toFixed(2)} ₽</div></div>
            <div style={{ background: (usersData.yuriy?.debt || 0) > 0 ? '#dc3545' : ((usersData.yuriy?.debt || 0) < 0 ? '#28a745' : '#6c757d'), color: 'white', padding: '8px 12px', borderRadius: '8px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: isMobile ? 'auto' : '15%', minWidth: '120px' }}>
              <span style={{ fontSize: '13px' }}>{(usersData.yuriy?.debt || 0) > 0 ? 'Должен' : ((usersData.yuriy?.debt || 0) < 0 ? 'Одолжил' : 'Долг')}</span>
              <span style={{ fontSize: '16px', fontWeight: 'bold' }}>{(usersData.yuriy?.debt || 0) !== 0 ? Math.abs(usersData.yuriy?.debt || 0).toFixed(2) + '₽' : '—'}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// --- ГЛАВНЫЙ КОМПОНЕНТ ---
function App() {
  const [activeTab, setActiveTab] = useState('inventory');
  const [items, setItems] = useState([]);
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadItems = async () => {
    try {
      const response = await fetch(`${API_URL}/items.php`);
      const data = await response.json();
      setItems(data);
      return data;
    } catch (error) {
      console.error('Ошибка загрузки товаров:', error);
      return [];
    }
  };

  const loadJobs = async () => {
    try {
      const response = await fetch(`${API_URL}/jobs.php`);
      const data = await response.json();
      setJobs(data);
      return data;
    } catch (error) {
      console.error('Ошибка загрузки выездов:', error);
      return [];
    }
  };

  useEffect(() => {
    const init = async () => {
      setLoading(true);
      await Promise.all([loadItems(), loadJobs()]);
      setLoading(false);
    };
    init();
  }, []);

  if (loading) {
    return (
      <div style={{ textAlign: 'center', marginTop: '100px' }}>
        <h2>🔄 Загрузка данных с сервера...</h2>
      </div>
    );
  }

  return (
    <PasswordGuard>
      <MobileStyles />
      <div style={styles.container}>
        <div style={styles.header}>
          <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
            <button style={styles.tabButton(activeTab === 'inventory')} onClick={() => setActiveTab('inventory')}>📦 </button>
            <button style={styles.tabButton(activeTab === 'jobs')} onClick={() => setActiveTab('jobs')}>🔧</button>
            <button style={styles.tabButton(activeTab === 'profitability')} onClick={() => setActiveTab('profitability')}>📊 </button>
          </div>
        </div>
        
        {activeTab === 'inventory' && (
          <InventoryPage 
            items={items} 
            setItems={setItems}
            onLoadItems={loadItems}
          />
        )}
        {activeTab === 'jobs' && (
          <JobsPage 
            items={items}
            setItems={setItems}
            jobs={jobs}
            setJobs={setJobs}
            onLoadJobs={loadJobs}
            onLoadItems={loadItems}
          />
        )}
        {activeTab === 'profitability' && (
          <ProfitabilityGuard>
            <ProfitabilityPage 
              items={items}
              jobs={jobs}
              setItems={setItems}
              setJobs={setJobs}
              onLoadItems={loadItems}
              onLoadJobs={loadJobs}
            />
          </ProfitabilityGuard>
        )}
      </div>
    </PasswordGuard>
  );
}

export default App;